export default [
  {
    "alias": "rsly-bell-s-mansion"
  },
  {
    "alias": "kiku-japanese-restaurant-new-york-2"
  },
  {
    "alias": "gastro-at-35-bar-and-restaurant-new-york"
  },
  {
    "alias": "beetle-house-la-los-angeles"
  },
  {
    "alias": "bar-crenn-san-francisco"
  },
  {
    "alias": "city-vineyard-new-york-2"
  },
  {
    "alias": "rsly-pamela-s-p-g-diner"
  },
  {
    "alias": "little-prince-new-york"
  },
  {
    "alias": "rsly-homemade-taqueria-bushwick"
  },
  {
    "alias": "rsly-wayward-fare"
  },
  {
    "alias": "del-friscos-grille-new-york"
  },
  {
    "alias": "601-miami-6"
  },
  {
    "alias": "malii-gramercy-new-york"
  },
  {
    "alias": "dons-bogam-bbq-and-wine-bar-new-york-3"
  },
  {
    "alias": "p-s-kitchen-new-york-3"
  },
  {
    "alias": "lillys-craft-and-kitchen-new-york"
  },
  {
    "alias": "juniors-restaurant-new-york-9"
  },
  {
    "alias": "kausa-new-york"
  },
  {
    "alias": "kemuri-japanese-barú-redwood-city-3"
  },
  {
    "alias": "jacob-soul-food-restaurant-new-york-2"
  },
  {
    "alias": "rsly-falafel-grill"
  },
  {
    "alias": "italianissimo-ristorante-new-york-2"
  },
  {
    "alias": "la-boite-en-bois-new-york-2"
  },
  {
    "alias": "st-eves-ho-ho-kus"
  },
  {
    "alias": "the-maze-new-york-3"
  },
  {
    "alias": "topaz-thai-authentic-new-york"
  },
  {
    "alias": "kyu-miami-miami"
  },
  {
    "alias": "ben-and-jacks-steakhouse-new-york-5"
  },
  {
    "alias": "love-makoto-washington"
  },
  {
    "alias": "rsly-the-peruvian-spot"
  },
  {
    "alias": "ananda-new-york-4"
  },
  {
    "alias": "scalini-fedeli-chatham"
  },
  {
    "alias": "rocco-steakhouse-new-york"
  },
  {
    "alias": "corner-social-new-york-2"
  },
  {
    "alias": "sugarfish-by-sushi-nozawa-los-angeles-10"
  },
  {
    "alias": "mccarthys-pub-nyc-new-york"
  },
  {
    "alias": "the-milling-room-new-york-2"
  },
  {
    "alias": "rsly-mariscos-culiacan"
  },
  {
    "alias": "la-masseria-new-york-3"
  },
  {
    "alias": "the-district-new-york"
  },
  {
    "alias": "modena-washington-2"
  },
  {
    "alias": "l-adresse-nomad-new-york-4"
  },
  {
    "alias": "paci-restaurant-southport"
  },
  {
    "alias": "wilfie-and-nell-new-york"
  },
  {
    "alias": "rsly-hi-eatery"
  },
  {
    "alias": "rsly-woodam-korean-bbq"
  },
  {
    "alias": "il-buco-new-york-2"
  },
  {
    "alias": "the-ainsworth-midtown-new-york"
  },
  {
    "alias": "insa-brooklyn"
  },
  {
    "alias": "delhi-masala-new-york"
  },
  {
    "alias": "bubo-new-york"
  },
  {
    "alias": "rumi-s-kitchen-washington"
  },
  {
    "alias": "rsly-oasis-pizza"
  },
  {
    "alias": "mastros-steakhouse-san-francisco-2"
  },
  {
    "alias": "rsly-garlic-olive"
  },
  {
    "alias": "viva-toro-brooklyn-3"
  },
  {
    "alias": "hemingways-on-the-beach-turks-and-caicos-miami"
  },
  {
    "alias": "rsly-izakaya-nana"
  },
  {
    "alias": "rsly-riviera-ristorante"
  },
  {
    "alias": "molos-weehawken-2"
  },
  {
    "alias": "the-grisly-pear-new-york"
  },
  {
    "alias": "rsly-pio-pio-2"
  },
  {
    "alias": "rsly-caf-rustica-new-jersey"
  },
  {
    "alias": "nr-new-york-4"
  },
  {
    "alias": "rsly-el-cata-mariscos-sushi-cortes"
  },
  {
    "alias": "amarone-scarlatto-new-york"
  },
  {
    "alias": "trulucks-oceans-finest-seafood-and-crab-miami"
  },
  {
    "alias": "llama-inn-brooklyn"
  },
  {
    "alias": "rsly-the-factory-southshore"
  },
  {
    "alias": "dirty-french-new-york"
  },
  {
    "alias": "trattoria-miami-beach"
  },
  {
    "alias": "rsly-haire-s-gulf-shrimp-south-loop"
  },
  {
    "alias": "bengal-tiger-indian-food-new-york"
  },
  {
    "alias": "bao-by-kaya-new-york-4"
  },
  {
    "alias": "spice-symphony-new-york-3"
  },
  {
    "alias": "rsly-lucky-house-kitchen"
  },
  {
    "alias": "taverna-kyclades-east-village-new-york-2"
  },
  {
    "alias": "maison-harlem-new-york"
  },
  {
    "alias": "rooftop-at-exchange-place-jersey-city-2"
  },
  {
    "alias": "mangia-57th-new-york"
  },
  {
    "alias": "rsly-oyaz-turkish-cuisine"
  },
  {
    "alias": "angelinas-pizzeria-napoletana-irvine-2"
  },
  {
    "alias": "chez-billy-sud-washington"
  },
  {
    "alias": "angelina-paris-new-york-4"
  },
  {
    "alias": "baar-baar-new-york-2"
  },
  {
    "alias": "rsly-rose-gose"
  },
  {
    "alias": "old-lisbon-restaurants-miami-miami"
  },
  {
    "alias": "ponty-bistro-new-york-3"
  },
  {
    "alias": "ootoya-times-square-new-york-2"
  },
  {
    "alias": "rsly-roxbury-diner"
  },
  {
    "alias": "hot-n-juicy-crawfish-washington"
  },
  {
    "alias": "el-nuevo-caridad-restaurant-new-york"
  },
  {
    "alias": "rsly-rodos-greek-cafe"
  },
  {
    "alias": "balthazar-new-york-2"
  },
  {
    "alias": "senya-new-york"
  },
  {
    "alias": "rsly-el-ostion-mariscos"
  },
  {
    "alias": "rsly-dolce-bene"
  },
  {
    "alias": "the-bygone-baltimore"
  },
  {
    "alias": "harlem-bar-b-q-new-york"
  },
  {
    "alias": "liuyishou-hot-pot-san-jose"
  },
  {
    "alias": "kao-new-york"
  },
  {
    "alias": "rsly-birrieria-y-menuderia-guadalajara"
  },
  {
    "alias": "rsly--gao-s-bbq-crab-new-york"
  },
  {
    "alias": "akdeniz-mediterranean-cuisine-new-york"
  },
  {
    "alias": "indian-summer-harlem-new-york"
  },
  {
    "alias": "rsly-capriccio---artisan-pizza-coffee"
  },
  {
    "alias": "m-korean-bbq-buena-park"
  },
  {
    "alias": "the-tyger-new-york-2"
  },
  {
    "alias": "harts-restaurant-brooklyn-2"
  },
  {
    "alias": "atti-brooklyn"
  },
  {
    "alias": "the-butchers-daughter-new-york-2"
  },
  {
    "alias": "margon-new-york"
  },
  {
    "alias": "state-bird-provisions-san-francisco"
  },
  {
    "alias": "wicked-willys-new-york"
  },
  {
    "alias": "bota-tapas-and-paella-bar-san-francisco-3"
  },
  {
    "alias": "buena-vista-restaurant-and-bar-new-york"
  },
  {
    "alias": "steam-shanghai-asian-fusion-new-york-2"
  },
  {
    "alias": "rsly-twin-oaks-lounge"
  },
  {
    "alias": "cocina-del-sur-new-york-2"
  },
  {
    "alias": "rsly-joomak"
  },
  {
    "alias": "izakaya-juraku-new-york-2"
  },
  {
    "alias": "planta-south-beach-miami-beach-3"
  },
  {
    "alias": "rsly-focacceria-ristorante"
  },
  {
    "alias": "rsly-creme-of-the-island-restaurant-and-juice-bar"
  },
  {
    "alias": "barcelona-waypointe-norwalk"
  },
  {
    "alias": "rsly-the-claremont-tavern"
  },
  {
    "alias": "le-gourmet-new-york"
  },
  {
    "alias": "the-vault-steakhouse-san-francisco-2"
  },
  {
    "alias": "rsly-sabor-piri-piri-kitchen"
  },
  {
    "alias": "crab-house-all-you-can-eat-seafood-new-york"
  },
  {
    "alias": "bourbon-steak-washington-dc-washington"
  },
  {
    "alias": "mama-s-cupboard-new-york-2"
  },
  {
    "alias": "rsly-corinne-at-the-domain"
  },
  {
    "alias": "benihana-san-francisco"
  },
  {
    "alias": "pubbelly-sushi-brickell-miami-4"
  },
  {
    "alias": "aromas-del-peru-coral-gables-coral-gables"
  },
  {
    "alias": "nari-san-francisco-3"
  },
  {
    "alias": "mister-jius-san-francisco"
  },
  {
    "alias": "loi-estiatorio-new-york"
  },
  {
    "alias": "margaritaville-times-square-new-york"
  },
  {
    "alias": "tamarind-new-york-4"
  },
  {
    "alias": "maya-new-york"
  },
  {
    "alias": "carla-new-york-2"
  },
  {
    "alias": "dutch-freds-new-york-2"
  },
  {
    "alias": "da-andrea-new-york"
  },
  {
    "alias": "abrazo-san-francisco-2"
  },
  {
    "alias": "ume-williamsburg-brooklyn"
  },
  {
    "alias": "camino-alto-san-francisco-2"
  },
  {
    "alias": "la-lanterna-cafe-and-grill-ridgewood"
  },
  {
    "alias": "rsly-mr-crabby-s-seafood-house-sports-bar-nj-"
  },
  {
    "alias": "park-tavern-san-francisco"
  },
  {
    "alias": "american-bar-new-york"
  },
  {
    "alias": "ana-bar-and-eatery-new-york"
  },
  {
    "alias": "a-salt-and-battery-new-york"
  },
  {
    "alias": "rsly-the-blue-goose-saloon"
  },
  {
    "alias": "harlem-tavern-new-york-2"
  },
  {
    "alias": "wokuni-new-york"
  },
  {
    "alias": "el-parador-cafe-new-york"
  },
  {
    "alias": "tudor-city-steakhouse-new-york"
  },
  {
    "alias": "ysabel-west-hollywood"
  },
  {
    "alias": "lafayette-grand-café-and-bakery-new-york"
  },
  {
    "alias": "sorrel-san-francisco-3"
  },
  {
    "alias": "glass-house-tavern-new-york"
  },
  {
    "alias": "hudson-clearwater-new-york"
  },
  {
    "alias": "o-by-claude-le-tohic-san-francisco-3"
  },
  {
    "alias": "rsly-mama-s-pizzeria-roxbury"
  },
  {
    "alias": "roots-steakhouse-ridgewood-3"
  },
  {
    "alias": "joes-stone-crab-miami-beach-3"
  },
  {
    "alias": "sushi-seki-chelsea-new-york"
  },
  {
    "alias": "ammoora-baltimore-2"
  },
  {
    "alias": "contento-new-york-city"
  },
  {
    "alias": "rsly-nan-xiang-soup-dumplings---king-of-prussia"
  },
  {
    "alias": "rsly-fare-from-here-on"
  },
  {
    "alias": "bedford-falls-new-york-2"
  },
  {
    "alias": "blue-fin-new-york"
  },
  {
    "alias": "the-fulton-by-jean-georges-new-york-2"
  },
  {
    "alias": "matador-room-miami-beach"
  },
  {
    "alias": "salma-new-york"
  },
  {
    "alias": "rsly-r-place-bar-eatery"
  },
  {
    "alias": "popular-new-york-3"
  },
  {
    "alias": "rsly-dam-a-hot-pot-bbq-ayce---austin-hotpot"
  },
  {
    "alias": "rsly-a-ejo-tribeca"
  },
  {
    "alias": "bobby-vans-steakhouse-washington"
  },
  {
    "alias": "yatenga-french-bistro-and-bar-new-york"
  },
  {
    "alias": "rsly-fig-lily-garden"
  },
  {
    "alias": "rsly-el-ranchito-los-3-hermanos"
  },
  {
    "alias": "china-chilcano-washington-2"
  },
  {
    "alias": "the-odeon-new-york"
  },
  {
    "alias": "turntable-at-lord-stanley-san-francisco"
  },
  {
    "alias": "rsly-the-nuaa-table"
  },
  {
    "alias": "rsly-ruta-ukrainian-restaurant"
  },
  {
    "alias": "rsly-river-grille"
  },
  {
    "alias": "rsly-loro-asian-smokehouse-bar"
  },
  {
    "alias": "sushi-by-m-new-york"
  },
  {
    "alias": "rsly-robeks-fresh-juices-smoothies"
  },
  {
    "alias": "boca-oyster-bar-bridgeport"
  },
  {
    "alias": "treadwell-park-new-york"
  },
  {
    "alias": "nangman-bbq-new-york-2"
  },
  {
    "alias": "massawa-new-york"
  },
  {
    "alias": "horses-los-angeles"
  },
  {
    "alias": "atera-new-york"
  },
  {
    "alias": "abaya-thai-new-york"
  },
  {
    "alias": "sagaponack-new-york-6"
  },
  {
    "alias": "rsly-OKAO"
  },
  {
    "alias": "rsly-taste-of-india"
  },
  {
    "alias": "rsly-the-commodore"
  },
  {
    "alias": "rsly-bella-s"
  },
  {
    "alias": "manhatta-new-york"
  },
  {
    "alias": "rsly-guzman-y-gomez---evanston"
  },
  {
    "alias": "ollies-sichuan-new-york-2"
  },
  {
    "alias": "hunan-slurp-new-york-2"
  },
  {
    "alias": "barcelona-wine-bar-cathedral-heights-washington-2"
  },
  {
    "alias": "keens-steakhouse-new-york"
  },
  {
    "alias": "rsly-naked-lunch"
  },
  {
    "alias": "poco-nyc-new-york-15"
  },
  {
    "alias": "the-oceanaire-seafood-room-washington-3"
  },
  {
    "alias": "taureau-new-york"
  },
  {
    "alias": "the-monocle-washington"
  },
  {
    "alias": "david-burke-tavern-new-york"
  },
  {
    "alias": "cousins-maine-lobster-new-york-new-york"
  },
  {
    "alias": "dirty-habit-san-francisco"
  },
  {
    "alias": "rsly-bryans-luncheonette"
  },
  {
    "alias": "delight-deli-and-grocery-hoboken"
  },
  {
    "alias": "r-lounge-at-two-times-square-new-york"
  },
  {
    "alias": "amarone-kitchen-and-wine-west-hollywood"
  },
  {
    "alias": "rsly-primrose"
  },
  {
    "alias": "the-champagne-bar-new-york-2"
  },
  {
    "alias": "rsly-brooklyn-crab"
  },
  {
    "alias": "junzi-kitchen-new-york-16"
  },
  {
    "alias": "rsly-chickpea-grill"
  },
  {
    "alias": "felice-56-new-york"
  },
  {
    "alias": "rsly-kayu"
  },
  {
    "alias": "rsly-jackie-inn"
  },
  {
    "alias": "rsly-jingles-jamaican-kuisine"
  },
  {
    "alias": "empire-steak-house-new-york-11"
  },
  {
    "alias": "three-roosters-new-york"
  },
  {
    "alias": "rsly-ny-kimchi"
  },
  {
    "alias": "rsly-kyo-matcha-alexandria"
  },
  {
    "alias": "healthy-choice-new-york"
  },
  {
    "alias": "rsly-old-mill-tavern"
  },
  {
    "alias": "blackbarn-new-york"
  },
  {
    "alias": "rsly-the-eatery"
  },
  {
    "alias": "her-name-was-carmen-new-york"
  },
  {
    "alias": "rsly-trattoria-bolu"
  },
  {
    "alias": "rsly-gitano-nyc"
  },
  {
    "alias": "matisse-washington"
  },
  {
    "alias": "barney-brown-new-york"
  },
  {
    "alias": "arisu-korean-bbq-buena-park-2"
  },
  {
    "alias": "odo-new-york"
  },
  {
    "alias": "tracks-raw-bar-and-grill-new-york-2"
  },
  {
    "alias": "traif-brooklyn"
  },
  {
    "alias": "rsly-marimbas-guatemalan-bakery-restaurant"
  },
  {
    "alias": "rsly-the-lunch-box"
  },
  {
    "alias": "rsly-sarafino-s-homestyle-italian"
  },
  {
    "alias": "sushi-sen-nin-new-york"
  },
  {
    "alias": "rsly-kin-da"
  },
  {
    "alias": "pocha-32-new-york"
  },
  {
    "alias": "rsly-new-nurlan-uyghur-restaurant"
  },
  {
    "alias": "table-d-hôte-new-york-2"
  },
  {
    "alias": "easy-company-washington"
  },
  {
    "alias": "yardbird-table-and-bar-miami-beach"
  },
  {
    "alias": "rsly-curbside-on-the-run"
  },
  {
    "alias": "the-rotunda-san-francisco-2"
  },
  {
    "alias": "rsly-alfanar-restaurant"
  },
  {
    "alias": "turkish-kitchen-new-york"
  },
  {
    "alias": "a16-san-francisco-4"
  },
  {
    "alias": "rsly-black-river-barn"
  },
  {
    "alias": "kocos-pub-baltimore"
  },
  {
    "alias": "perry-st-new-york"
  },
  {
    "alias": "royal-35-steakhouse-new-york"
  },
  {
    "alias": "rsly-hungry-bird"
  },
  {
    "alias": "tadich-grill-san-francisco"
  },
  {
    "alias": "westville-ny-2"
  },
  {
    "alias": "rsly-the-empanada-spot"
  },
  {
    "alias": "glur-thai-new-york"
  },
  {
    "alias": "rsly-petite-crevette"
  },
  {
    "alias": "rsly-cornerstone-pizzeria"
  },
  {
    "alias": "rsly-barcelona-wine-bar"
  },
  {
    "alias": "rsly-bird-dog"
  },
  {
    "alias": "rsly-good-guys-burger-company"
  },
  {
    "alias": "dōma-miami-3"
  },
  {
    "alias": "lola-taverna-new-york"
  },
  {
    "alias": "rsly-kabab-paradise"
  },
  {
    "alias": "red-bamboo-new-york"
  },
  {
    "alias": "rsly-smokin-toad-s-bbq"
  },
  {
    "alias": "the-huntley-taverne-summit-2"
  },
  {
    "alias": "rsly-lupa-ristorante"
  },
  {
    "alias": "44-and-x-hells-kitchen-new-york-5"
  },
  {
    "alias": "the-bar-downstairs-and-kitchen-new-york-3"
  },
  {
    "alias": "bamboo-sushi-new-york-5"
  },
  {
    "alias": "4-charles-prime-rib-new-york"
  },
  {
    "alias": "avert-brasserie-west-hartford-2"
  },
  {
    "alias": "leuca-brooklyn"
  },
  {
    "alias": "cook-eatery-new-york"
  },
  {
    "alias": "rsly-meat-potatoes"
  },
  {
    "alias": "sadelles-new-york"
  },
  {
    "alias": "rsly-carla"
  },
  {
    "alias": "dear-mama-new-york-3"
  },
  {
    "alias": "souvlaki-gr-new-york-9"
  },
  {
    "alias": "british-bankers-club-menlo-park-4"
  },
  {
    "alias": "johns-of-times-square-new-york-2"
  },
  {
    "alias": "row-house-new-york-6"
  },
  {
    "alias": "follia-new-york"
  },
  {
    "alias": "charlie-bird-new-york"
  },
  {
    "alias": "pao-by-paul-qui-miami-beach-3"
  },
  {
    "alias": "bella-blu-new-york"
  },
  {
    "alias": "sushi-ryusei-new-york-2"
  },
  {
    "alias": "rsly-smoothie-king"
  },
  {
    "alias": "le-pavillon-new-york"
  },
  {
    "alias": "osteria-della-pace-new-york"
  },
  {
    "alias": "cafe-cluny-new-york-3"
  },
  {
    "alias": "prime-italian-miami-beach"
  },
  {
    "alias": "rsly-the-ktm-kitchen"
  },
  {
    "alias": "rooh-palo-alto-palo-alto-2"
  },
  {
    "alias": "rsly-mojo"
  },
  {
    "alias": "rsly-panatieri-s-pizza-pasta--bedminster"
  },
  {
    "alias": "prime-one-twelve-miami-beach"
  },
  {
    "alias": "amor-loco-new-york"
  },
  {
    "alias": "campagnola-restaurant-new-york"
  },
  {
    "alias": "bucks-fishing-and-camping-washington"
  },
  {
    "alias": "florio-bar-and-cafe-san-francisco"
  },
  {
    "alias": "rsly-himalayan-sherpa-kitchen"
  },
  {
    "alias": "zou-zou-s-new-york-3"
  },
  {
    "alias": "rsly-kbbq-cup"
  },
  {
    "alias": "uotora-brooklyn"
  },
  {
    "alias": "serafina-new-york-32"
  },
  {
    "alias": "sanyuu-west-new-york"
  },
  {
    "alias": "charlie-palmer-steak-new-york-new-york"
  },
  {
    "alias": "kali-restaurant-los-angeles"
  },
  {
    "alias": "yum-yum-too-new-york"
  },
  {
    "alias": "mighty-quinns-barbeque-new-york-5"
  },
  {
    "alias": "rsly-5-rabanitos-hyde-park"
  },
  {
    "alias": "overlook-new-york-2"
  },
  {
    "alias": "mokbar-new-york"
  },
  {
    "alias": "cho-dang-gol-korean-restaurant-new-york"
  },
  {
    "alias": "toro-toro-miami-7"
  },
  {
    "alias": "teriyaki-r-us-new-york-4"
  },
  {
    "alias": "osteria-laguna-new-york"
  },
  {
    "alias": "mikes-ristorante-norwalk"
  },
  {
    "alias": "inside-park-at-st-barts-new-york-2"
  },
  {
    "alias": "maestro-pasta-new-york-2"
  },
  {
    "alias": "rsly-kyuramen-x-tbaar---pittsburgh"
  },
  {
    "alias": "rsly-pulled-fork-bbq"
  },
  {
    "alias": "rsly-the-hunter-s-hound"
  },
  {
    "alias": "chu-ros-thai-new-york"
  },
  {
    "alias": "pure-thai-cookhouse-new-york"
  },
  {
    "alias": "duck-duck-goose-washington-2"
  },
  {
    "alias": "quality-bistro-new-york-3"
  },
  {
    "alias": "bouche-san-francisco"
  },
  {
    "alias": "nicolas-restaurant-new-york"
  },
  {
    "alias": "rsly-small-cheval--lincoln-park"
  },
  {
    "alias": "lin-and-daughters-new-york"
  },
  {
    "alias": "tomi-jazz-new-york"
  },
  {
    "alias": "elenis-new-york-3"
  },
  {
    "alias": "ai-fiori-new-york"
  },
  {
    "alias": "palio-san-francisco-2"
  },
  {
    "alias": "joji-new-york-2"
  },
  {
    "alias": "hosteria-romana-miami-beach"
  },
  {
    "alias": "the-grey-dog-new-york-18"
  },
  {
    "alias": "rsly-indo-mix"
  },
  {
    "alias": "rsly-fire-wine-park-ridge"
  },
  {
    "alias": "l-antagoniste-brooklyn"
  },
  {
    "alias": "nm-cafe-palo-alto-3"
  },
  {
    "alias": "rsly-other-way-kitchen"
  },
  {
    "alias": "lilia-brooklyn"
  },
  {
    "alias": "sushi-ann-restaurant-new-york"
  },
  {
    "alias": "tuome-new-york-2"
  },
  {
    "alias": "antonucci-cafe-new-york"
  },
  {
    "alias": "chez-napoleon-new-york"
  },
  {
    "alias": "petit-trois-los-angeles-15"
  },
  {
    "alias": "martel-restaurant-fairfield"
  },
  {
    "alias": "feile-new-york-13"
  },
  {
    "alias": "lokal-eatery-and-bar-jersey-city-2"
  },
  {
    "alias": "rsly-whatsub"
  },
  {
    "alias": "mathilde-french-bistro-san-francisco"
  },
  {
    "alias": "rsly-la-griglia"
  },
  {
    "alias": "rsly-ruckus-cafe"
  },
  {
    "alias": "hawksmoor-new-york"
  },
  {
    "alias": "gonzalez-y-gonzalez-new-york-2"
  },
  {
    "alias": "wogies-bar-and-grill-new-york-3"
  },
  {
    "alias": "hillstone-restaurant-coral-gables-2"
  },
  {
    "alias": "florida-cookery-miami-beach-2"
  },
  {
    "alias": "bukhara-grill-indian-spice-rave-new-york"
  },
  {
    "alias": "foova-tenafly"
  },
  {
    "alias": "claw-daddys-new-york"
  },
  {
    "alias": "panineria-italiana-new-york"
  },
  {
    "alias": "pisco-bar-saratoga"
  },
  {
    "alias": "stk-steakhouse-downtown-new-york-2"
  },
  {
    "alias": "cipriani-downtown-miami-miami-6"
  },
  {
    "alias": "cipriani-wall-street-new-york-2"
  },
  {
    "alias": "casa-ora-brooklyn"
  },
  {
    "alias": "rsly-takoma-beverage-company"
  },
  {
    "alias": "rsly-marechiaro-s-italian-restaurant"
  },
  {
    "alias": "rsly-nha-trang-restaurant"
  },
  {
    "alias": "noreetuh-new-york"
  },
  {
    "alias": "satis-bistro-jersey-city"
  },
  {
    "alias": "park-west-tavern-ridgewood"
  },
  {
    "alias": "stubborn-seed-miami-beach"
  },
  {
    "alias": "tang-pavilion-new-york-3"
  },
  {
    "alias": "rsly-verona-restaurant"
  },
  {
    "alias": "grand-bar-and-salon-new-york-2"
  },
  {
    "alias": "tiger-sugar-new-york-city"
  },
  {
    "alias": "rsly-viva-la-vida-mexican-bar-grill"
  },
  {
    "alias": "rsly-spoko"
  },
  {
    "alias": "rsly-taqueria-jefe-loco"
  },
  {
    "alias": "frankies-457-spuntino-brooklyn-3"
  },
  {
    "alias": "mamo-restaurant-new-york"
  },
  {
    "alias": "blume-hütte-new-york"
  },
  {
    "alias": "rsly-el-parche-cafe-restaurant"
  },
  {
    "alias": "rsly-charleys-cheesesteaks-and-wings"
  },
  {
    "alias": "byblos-miami-miami-beach"
  },
  {
    "alias": "rsly-wingstop"
  },
  {
    "alias": "rsly-miss-maryland-crab-d-c"
  },
  {
    "alias": "sfoglina-downtown-washington"
  },
  {
    "alias": "the-bridge-los-angeles-2"
  },
  {
    "alias": "spunto-new-york-7"
  },
  {
    "alias": "bacalls-new-york-2"
  },
  {
    "alias": "figaro-new-york-3"
  },
  {
    "alias": "rsly-blue-sushi-sake-grill"
  },
  {
    "alias": "la-brochette-new-york"
  },
  {
    "alias": "blind-tiger-ale-house-new-york"
  },
  {
    "alias": "rsly-the-black-horse-tavern-pub"
  },
  {
    "alias": "torch-and-crown-brewing-company-new-york"
  },
  {
    "alias": "fiorino-ristorante-and-bar-summit"
  },
  {
    "alias": "rsly-market-tavern-restaurant-bar"
  },
  {
    "alias": "rsly-rooted3"
  },
  {
    "alias": "macarthur-park-palo-alto-3"
  },
  {
    "alias": "aroqa-new-york"
  },
  {
    "alias": "mangia-422-madison-new-york"
  },
  {
    "alias": "baires-grill-brickell-miami-3"
  },
  {
    "alias": "la-goulue-new-york-2"
  },
  {
    "alias": "rsly-la-mexicana-grill"
  },
  {
    "alias": "oceana-new-york-2"
  },
  {
    "alias": "rsly-jabs"
  },
  {
    "alias": "rsly-muddy-waterz-bar-grill"
  },
  {
    "alias": "gordon-ramsay-fish-and-chips-new-york-4"
  },
  {
    "alias": "il-gattopardo-new-york-2"
  },
  {
    "alias": "pie-corps-brooklyn"
  },
  {
    "alias": "longo-bros-new-york"
  },
  {
    "alias": "rsly-aeb-authentic-cuisine"
  },
  {
    "alias": "mainrō-los-angeles-3"
  },
  {
    "alias": "antons-new-york"
  },
  {
    "alias": "l-antica-pizzeria-da-michele-los-angeles-2"
  },
  {
    "alias": "boia-de-miami"
  },
  {
    "alias": "perrys-steakhouse-and-grille-coral-gables-coral-gables"
  },
  {
    "alias": "the-mark-restaurant-new-york-2"
  },
  {
    "alias": "rsly-the-prospect-tavern"
  },
  {
    "alias": "rsly-the-dor-stop-restaurant"
  },
  {
    "alias": "rsly-romeos"
  },
  {
    "alias": "rsly-fired-up-brick-oven-tap-house"
  },
  {
    "alias": "oceans-new-york-new-york"
  },
  {
    "alias": "blue-note-new-york-new-york-5"
  },
  {
    "alias": "sea-grill-coral-gables"
  },
  {
    "alias": "the-long-room-new-york"
  },
  {
    "alias": "dante-new-york"
  },
  {
    "alias": "rsly-spanish-tavern-of-mountainside"
  },
  {
    "alias": "palma-new-york"
  },
  {
    "alias": "rancho-tequileria-new-york-3"
  },
  {
    "alias": "rsly-levante"
  },
  {
    "alias": "tam-sang-thai-kitchen-new-york-2"
  },
  {
    "alias": "pig-n-whistle-public-house-new-york"
  },
  {
    "alias": "park-east-kosher-butchers-new-york-2"
  },
  {
    "alias": "il-buco-alimentari-and-vineria-new-york-2"
  },
  {
    "alias": "robert-new-york-25"
  },
  {
    "alias": "beauty-and-essex-new-york-city"
  },
  {
    "alias": "quince-san-francisco"
  },
  {
    "alias": "mortons-the-steakhouse-burbank"
  },
  {
    "alias": "rsly-mizuki-asian-fusion-and-hibachi"
  },
  {
    "alias": "neros-grille-livingston"
  },
  {
    "alias": "pappas-taverna-new-york-2"
  },
  {
    "alias": "rsly-holy-cow-burgers"
  },
  {
    "alias": "yardbird-washington-3"
  },
  {
    "alias": "veranda-miami-beach-2"
  },
  {
    "alias": "portofinos-restaurant-and-bar-new-haven"
  },
  {
    "alias": "rsly-miami-potato-factory"
  },
  {
    "alias": "rsly-perfection-at-its-best-catering"
  },
  {
    "alias": "tinas-cuban-cuisine-new-york-13"
  },
  {
    "alias": "the-modern-new-york-3"
  },
  {
    "alias": "madison-restaurant-new-york-2"
  },
  {
    "alias": "new-heights-restaurant-washington-3"
  },
  {
    "alias": "d-oro-ristorante-chatham"
  },
  {
    "alias": "rsly-pancheros-mexican-grill---bedminster"
  },
  {
    "alias": "seaspice-brasserie-and-lounge-miami"
  },
  {
    "alias": "blue-maiz-new-york"
  },
  {
    "alias": "astro-restaurant-new-york"
  },
  {
    "alias": "sandbox-miami-beach-2"
  },
  {
    "alias": "rsly-balvanera"
  },
  {
    "alias": "sandros-new-york"
  },
  {
    "alias": "flame-hibachi-new-york-4"
  },
  {
    "alias": "take31-new-york"
  },
  {
    "alias": "olea-new-haven-2"
  },
  {
    "alias": "rsly-donburi-rice-bowls"
  },
  {
    "alias": "dua-kafe-new-york"
  },
  {
    "alias": "rsly-via-carota"
  },
  {
    "alias": "le-baratin-new-york"
  },
  {
    "alias": "rsly-the-committed-pig"
  },
  {
    "alias": "ridgelys-market-baltimore"
  },
  {
    "alias": "cipriani-downtown-new-york"
  },
  {
    "alias": "cafe-los-gauchitos-ii-miami"
  },
  {
    "alias": "top-of-the-mark-san-francisco"
  },
  {
    "alias": "haymaker-bar-and-kitchen-new-york"
  },
  {
    "alias": "match-65-brasserie-new-york-6"
  },
  {
    "alias": "porta-blu-menlo-park-2"
  },
  {
    "alias": "rsly-iykyk"
  },
  {
    "alias": "m-wells-long-island-city-2"
  },
  {
    "alias": "rsly-faubourg-weehawken"
  },
  {
    "alias": "christys-coral-gables"
  },
  {
    "alias": "rsly-kavsarexpress"
  },
  {
    "alias": "gaonnuri-new-york-3"
  },
  {
    "alias": "mazi-washington-2"
  },
  {
    "alias": "rsly-hav-mar"
  },
  {
    "alias": "mimis-italian-restaurant-and-piano-bar-new-york"
  },
  {
    "alias": "delilah-west-hollywood"
  },
  {
    "alias": "the-east-pole-new-york"
  },
  {
    "alias": "cava-restaurant-southington"
  },
  {
    "alias": "abbalé-telavivian-kitchen-miami-beach"
  },
  {
    "alias": "rsly-jaew-thai-cuisine"
  },
  {
    "alias": "bea-new-york"
  },
  {
    "alias": "rsly-the-flame-barbeque"
  },
  {
    "alias": "sushi-ike-los-angeles"
  },
  {
    "alias": "cypriana-of-roland-park-baltimore-2"
  },
  {
    "alias": "john-sullivans-new-york"
  },
  {
    "alias": "celestine-brooklyn"
  },
  {
    "alias": "quality-eats-new-york"
  },
  {
    "alias": "south-of-the-clouds-new-york"
  },
  {
    "alias": "rsly-the-other-place"
  },
  {
    "alias": "rsly-prestige-diner-restaurant"
  },
  {
    "alias": "sushi-ogawa-washington"
  },
  {
    "alias": "the-brooklyneer-new-york"
  },
  {
    "alias": "juniper-restaurant-washington-3"
  },
  {
    "alias": "wondee-siam-new-york-3"
  },
  {
    "alias": "mccormick-and-kuletos-seafood-and-steaks-san-francisco-2"
  },
  {
    "alias": "top-thai-vintage-new-york-3"
  },
  {
    "alias": "caviar-russe-new-york"
  },
  {
    "alias": "rsly-54-main-bar-grille"
  },
  {
    "alias": "rsly-monte-casa"
  },
  {
    "alias": "rsly-1865-steak-seafood-cigars"
  },
  {
    "alias": "docks-oyster-bar-and-seafood-grill-new-york"
  },
  {
    "alias": "hatchets-and-hops-brooklyn"
  },
  {
    "alias": "petrarca-cucina-e-vino-new-york-2"
  },
  {
    "alias": "duane-park-new-york-3"
  },
  {
    "alias": "brine-new-york"
  },
  {
    "alias": "tue-thai-restaurant-new-york"
  },
  {
    "alias": "rsly-steel-mill-saloon"
  },
  {
    "alias": "rsly-the-burger-den"
  },
  {
    "alias": "mesamar-seafood-table-coral-gables"
  },
  {
    "alias": "sushi-kai-new-york-3"
  },
  {
    "alias": "rsly-adam-s-chicken-pocha"
  },
  {
    "alias": "la-grande-boucherie-new-york-2"
  },
  {
    "alias": "north-beach-restaurant-san-francisco"
  },
  {
    "alias": "rsly-spirits-tales"
  },
  {
    "alias": "rsly-bricks-wood-fired-pizza---yorktown-lombard"
  },
  {
    "alias": "maydan-washington-2"
  },
  {
    "alias": "rossinis-new-york"
  },
  {
    "alias": "serengeti-baltimore"
  },
  {
    "alias": "rsly-colima-taqueria"
  },
  {
    "alias": "rsly-jet-s-pizza"
  },
  {
    "alias": "con-amore-ristorante-corona"
  },
  {
    "alias": "menkoi-sato-new-york-2"
  },
  {
    "alias": "crown-shy-new-york-2"
  },
  {
    "alias": "rsly-gyu-kaku-japanese-bbq"
  },
  {
    "alias": "hakkasan-miami-miami-beach"
  },
  {
    "alias": "pearl-street-supper-club-brooklyn"
  },
  {
    "alias": "le-papillon-san-jose"
  },
  {
    "alias": "boqueria-new-york-16"
  },
  {
    "alias": "rsly-il-nocello-ristorante-italiano"
  },
  {
    "alias": "the-boil-jersey-city"
  },
  {
    "alias": "rsly-silver"
  },
  {
    "alias": "emilios-ballato-new-york"
  },
  {
    "alias": "raouls-restaurant-new-york"
  },
  {
    "alias": "rsly-la-fonda-de-ofe"
  },
  {
    "alias": "tai-pan-palo-alto-3"
  },
  {
    "alias": "yakiniku-toraji-new-york"
  },
  {
    "alias": "primal-cut-steakhouse-new-york"
  },
  {
    "alias": "mama-mia-44-sw-new-york-2"
  },
  {
    "alias": "rsly-toca-vez"
  },
  {
    "alias": "a-fish-called-avalon-miami-beach-2"
  },
  {
    "alias": "rsly-chick-fil-a-las-am-ricas"
  },
  {
    "alias": "gran-morsi-new-york"
  },
  {
    "alias": "sushi-by-bou-jersey-city-jersey-city-4"
  },
  {
    "alias": "rsly-greek-kitchen-college-point"
  },
  {
    "alias": "rsly-siempre-algo"
  },
  {
    "alias": "felice-64-new-york"
  },
  {
    "alias": "suteishi-new-york-3"
  },
  {
    "alias": "silver-lyan-washington"
  },
  {
    "alias": "rsly-the-salt-line"
  },
  {
    "alias": "rsly-fox-s-pizza-den-monongahela-pa-"
  },
  {
    "alias": "blue-hill-new-york"
  },
  {
    "alias": "rsly-il-monello"
  },
  {
    "alias": "altesi-ristorante-new-york"
  },
  {
    "alias": "seven-hills-san-francisco"
  },
  {
    "alias": "zuma-miami-2"
  },
  {
    "alias": "pascals-on-ponce-coral-gables"
  },
  {
    "alias": "rsly-luna-rossa-restaurant"
  },
  {
    "alias": "raku-new-york-6"
  },
  {
    "alias": "kimika-new-york"
  },
  {
    "alias": "berlin-currywurst-new-york-3"
  },
  {
    "alias": "zawa-japanese-new-york"
  },
  {
    "alias": "atoboy-new-york"
  },
  {
    "alias": "rsly-backstage-bar-grill"
  },
  {
    "alias": "strip-house-downtown-new-york-3"
  },
  {
    "alias": "heirloom-farmhouse-kitchen-irvine"
  },
  {
    "alias": "rsly-nana-s-kitchen-new-york"
  },
  {
    "alias": "rsly-big-ed-s-taphouse-and-grill"
  },
  {
    "alias": "terre-brooklyn"
  },
  {
    "alias": "state-grill-and-bar-new-york"
  },
  {
    "alias": "crave-fishbar-new-york"
  },
  {
    "alias": "rsly-dietch-s-bar-grille"
  },
  {
    "alias": "rsly-la-gran-uruguaya-restaurant"
  },
  {
    "alias": "osteria-delbianco-new-york"
  },
  {
    "alias": "j-s-kitchen-new-york-new-york"
  },
  {
    "alias": "rsly-chi-mac-zip"
  },
  {
    "alias": "rsly-bobo-s-crab-shack-fordham-"
  },
  {
    "alias": "txikito-new-york"
  },
  {
    "alias": "la-savane-new-york"
  },
  {
    "alias": "armonie-new-york"
  },
  {
    "alias": "rsly-when-in-bangkok"
  },
  {
    "alias": "rsly-chopt-creative-salad-co-"
  },
  {
    "alias": "rsly-small-cheval--lincoln-square"
  },
  {
    "alias": "rsly-farmer-s-fridge"
  },
  {
    "alias": "kamasu-by-kissaki-new-york"
  },
  {
    "alias": "rsly-sarku-japan"
  },
  {
    "alias": "fogo-de-chao-brazilian-steakhouse-new-york-6"
  },
  {
    "alias": "rsly-minetta-tavern-dc"
  },
  {
    "alias": "kuun-brooklyn"
  },
  {
    "alias": "rsly-masseria-italian-steakhouse"
  },
  {
    "alias": "roof-terrace-restaurant-washington-3"
  },
  {
    "alias": "the-elgin-new-york"
  },
  {
    "alias": "carbone-new-york"
  },
  {
    "alias": "tao-uptown-new-york-2"
  },
  {
    "alias": "tavern-on-jane-new-york"
  },
  {
    "alias": "3-giovani-new-york"
  },
  {
    "alias": "sushi-seki-new-york-9"
  },
  {
    "alias": "rsly-casa-tulum"
  },
  {
    "alias": "rsly-la-licor-panamericana"
  },
  {
    "alias": "blue-haven-new-york"
  },
  {
    "alias": "chateau-49-bar-a-vin-new-york"
  },
  {
    "alias": "michaels-new-york"
  },
  {
    "alias": "azumi-baltimore"
  },
  {
    "alias": "tonys-di-napoli-new-york-4"
  },
  {
    "alias": "donato-enoteca-redwood-city"
  },
  {
    "alias": "mémé-mediterranean-new-york-4"
  },
  {
    "alias": "mr-chow-miami-beach"
  },
  {
    "alias": "springbone-kitchen-new-york"
  },
  {
    "alias": "antica-pesa-brooklyn-3"
  },
  {
    "alias": "stk-steakhouse-midtown-nyc-new-york"
  },
  {
    "alias": "lasagna-chelsea-restaurant-new-york-5"
  },
  {
    "alias": "rsly-arepa-express-mannheim"
  },
  {
    "alias": "l-atelier-de-joel-robuchon-miami-2"
  },
  {
    "alias": "chickpea-manhattan-8"
  },
  {
    "alias": "rsly-delicious-heights"
  },
  {
    "alias": "chelsea-ristorante-new-york"
  },
  {
    "alias": "5ive-spice-new-york-2"
  },
  {
    "alias": "the-clocktower-new-york"
  },
  {
    "alias": "medium-rare-washington"
  },
  {
    "alias": "e-mo-new-york"
  },
  {
    "alias": "la-mar-by-gastón-acurio-miami-6"
  },
  {
    "alias": "rsly-crispy-burger"
  },
  {
    "alias": "socarrat-paella-bar-chelsea-new-york-3"
  },
  {
    "alias": "silvana-new-york"
  },
  {
    "alias": "north-square-new-york"
  },
  {
    "alias": "rsly-dea-burek"
  },
  {
    "alias": "loch-bar-baltimore"
  },
  {
    "alias": "moms-kitchen-and-bar-new-york"
  },
  {
    "alias": "sveta-new-york"
  },
  {
    "alias": "cantina-la-veinte-miami-miami-2"
  },
  {
    "alias": "bombay-grill-house-new-york-3"
  },
  {
    "alias": "dill-and-parsley-new-york"
  },
  {
    "alias": "r-house-wynwood-miami-2"
  },
  {
    "alias": "nippon-new-york"
  },
  {
    "alias": "rsly-storming-crab"
  },
  {
    "alias": "hutaoli-music-restaurant-and-bar-new-york"
  },
  {
    "alias": "shanghai-mong-new-york"
  },
  {
    "alias": "delmonicos-new-york"
  },
  {
    "alias": "rsly-falafel-inc"
  },
  {
    "alias": "playwright-irish-pub-new-york-3"
  },
  {
    "alias": "rsly-rosati-s-pizza"
  },
  {
    "alias": "saigon-shack-new-york"
  },
  {
    "alias": "mercato-della-pescheria-espanola-way-miami-beach-2"
  },
  {
    "alias": "rsly-shia"
  },
  {
    "alias": "wollensky-grill-new-york"
  },
  {
    "alias": "rsly-papparich"
  },
  {
    "alias": "brisas-del-mar-new-york"
  },
  {
    "alias": "rsly-petite-boucherie"
  },
  {
    "alias": "rsly-end-of-elm"
  },
  {
    "alias": "woodmont-grill-bethesda"
  },
  {
    "alias": "rsly-the-speckled-egg-pgh"
  },
  {
    "alias": "restaurant-serenade-chatham"
  },
  {
    "alias": "jojo-restaurant-and-bar-washington"
  },
  {
    "alias": "porter-house-bar-and-grill-new-york"
  },
  {
    "alias": "bowery-meat-company-new-york"
  },
  {
    "alias": "mannas-new-york-5"
  },
  {
    "alias": "sea-fire-grill-new-york"
  },
  {
    "alias": "lelabar-new-york-2"
  },
  {
    "alias": "pinto-garden-new-york-3"
  },
  {
    "alias": "rosemarys-new-york"
  },
  {
    "alias": "rsly-old-glory-restaurant"
  },
  {
    "alias": "grams-bbq-garden-grove-2"
  },
  {
    "alias": "rsly-pelicana-chicken"
  },
  {
    "alias": "calle-dao-bryant-park-new-york"
  },
  {
    "alias": "rsly-black-bear-restaurant-bar"
  },
  {
    "alias": "casa-la-femme-new-york-2"
  },
  {
    "alias": "bocca-di-bacco-new-york-12"
  },
  {
    "alias": "rsly-la-casa-del-taco---washington-heights"
  },
  {
    "alias": "rsly-lesly-sport-bar-grill"
  },
  {
    "alias": "rsly-buffalo-wild-wings"
  },
  {
    "alias": "lattanzi-restaurant-new-york"
  },
  {
    "alias": "don-antonio-new-york-5"
  },
  {
    "alias": "saga-new-york-6"
  },
  {
    "alias": "rsly-pret-a-manger"
  },
  {
    "alias": "frascati-san-francisco"
  },
  {
    "alias": "quantum-leap-new-york-4"
  },
  {
    "alias": "taam-tov-new-york"
  },
  {
    "alias": "rsly-district-rico"
  },
  {
    "alias": "montes-trattoria-new-york-2"
  },
  {
    "alias": "briciola-new-york"
  },
  {
    "alias": "the-elk-new-york"
  },
  {
    "alias": "essex-new-york"
  },
  {
    "alias": "east-side-restaurant-new-britain"
  },
  {
    "alias": "skirt-steak-new-york"
  },
  {
    "alias": "rsly-delhi-spice"
  },
  {
    "alias": "nougatine-at-jean-georges-new-york-3"
  },
  {
    "alias": "rsly-piattino-a-neighborhood-bistro"
  },
  {
    "alias": "masala-king-new-york"
  },
  {
    "alias": "bottega-restaurant-new-york"
  },
  {
    "alias": "rsly-super-stuffed-burgers"
  },
  {
    "alias": "rsly-black-river-catering"
  },
  {
    "alias": "jaspers-taphouse-kitchen-new-york"
  },
  {
    "alias": "fogo-de-chao-brazilian-steakhouse-miami-beach-10"
  },
  {
    "alias": "osteria-al-doge-new-york"
  },
  {
    "alias": "rsly-pizza-brothers-bedminster"
  },
  {
    "alias": "nonna-beppa-soho-new-york"
  },
  {
    "alias": "rsly-smokin-brew-b-q"
  },
  {
    "alias": "hyun-new-york"
  },
  {
    "alias": "perrine-new-york-city"
  },
  {
    "alias": "the-dining-room-short-hills-2"
  },
  {
    "alias": "costas-arepa-bar-new-york"
  },
  {
    "alias": "filomena-ristorante-washington"
  },
  {
    "alias": "joseph-leonard-new-york"
  },
  {
    "alias": "fjord-fish-market-darien"
  },
  {
    "alias": "rsly-annie-s-deli"
  },
  {
    "alias": "marc-forgione-new-york-2"
  },
  {
    "alias": "colonie-brooklyn"
  },
  {
    "alias": "the-bar-room-new-york-7"
  },
  {
    "alias": "rsly-mi-taqueria-restaurant"
  },
  {
    "alias": "rsly-pokeshop-montrouge"
  },
  {
    "alias": "rsly-franks-pizza-and-italian-restaurant-mendham-"
  },
  {
    "alias": "rsly-dante-s-italian-restaurant"
  },
  {
    "alias": "boucherie-west-village-new-york-3"
  },
  {
    "alias": "cassidys-pub-and-restaurant-new-york"
  },
  {
    "alias": "benjamin-steakhouse-prime-new-york-4"
  },
  {
    "alias": "rsly-cabana"
  },
  {
    "alias": "lucky-cat-new-york-2"
  },
  {
    "alias": "rsly-the-burger-temple-weehawken"
  },
  {
    "alias": "rsly-anticonquista-caf-pilsen-"
  },
  {
    "alias": "filé-gumbo-bar-new-york"
  },
  {
    "alias": "bondst-new-york-2"
  },
  {
    "alias": "banter-new-york"
  },
  {
    "alias": "il-postino-new-york-3"
  },
  {
    "alias": "haswell-greens-new-york-3"
  },
  {
    "alias": "rsly-the-parlor-dim-sum"
  },
  {
    "alias": "rsly-sammy-s-ye-old-cider-mill"
  },
  {
    "alias": "mint-masala-new-york"
  },
  {
    "alias": "1789-restaurant-and-bar-washington"
  },
  {
    "alias": "the-lavaux-new-york"
  },
  {
    "alias": "rsly-singing-soul-catering"
  },
  {
    "alias": "rsly-shorty-s---waterfront"
  },
  {
    "alias": "tony-and-joes-seafood-place-washington"
  },
  {
    "alias": "gramercy-tavern-new-york"
  },
  {
    "alias": "anything-at-all-new-york-2"
  },
  {
    "alias": "dk-restaurant-nyc-new-york"
  },
  {
    "alias": "shiki-omakase-new-york-2"
  },
  {
    "alias": "genki-omakase-new-york"
  },
  {
    "alias": "amarone-ny-new-york-2"
  },
  {
    "alias": "haenyeo-brooklyn"
  },
  {
    "alias": "rsly-cheli-flushing-"
  },
  {
    "alias": "iron-age-washington-2"
  },
  {
    "alias": "trestle-san-francisco-5"
  },
  {
    "alias": "naro-new-york"
  },
  {
    "alias": "l-avenue-at-saks-new-york"
  },
  {
    "alias": "senza-gluten-new-york-2"
  },
  {
    "alias": "rsly-muddy-waters-gastropub"
  },
  {
    "alias": "rsly-kyuramen---long-island-city"
  },
  {
    "alias": "rsly-molos"
  },
  {
    "alias": "moti-mahal-delux-new-york"
  },
  {
    "alias": "giardino-d-oro-new-york"
  },
  {
    "alias": "zucca-coral-gables"
  },
  {
    "alias": "rsly-ayayay---mexican-eatery"
  },
  {
    "alias": "the-loeb-boathouse-central-park-new-york-4"
  },
  {
    "alias": "atelier-florian-new-haven"
  },
  {
    "alias": "fleming-s-prime-steakhouse-and-wine-bar-palo-alto"
  },
  {
    "alias": "métier-washington-4"
  },
  {
    "alias": "carousel-restaurant-los-angeles"
  },
  {
    "alias": "ettan-palo-alto"
  },
  {
    "alias": "astra-miami-4"
  },
  {
    "alias": "jukai-new-york"
  },
  {
    "alias": "friedmans-new-york-71"
  },
  {
    "alias": "taiki-brooklyn"
  },
  {
    "alias": "rsly-tatva"
  },
  {
    "alias": "rsly-istanbloom-mediterranean-restaurant"
  },
  {
    "alias": "halves-boiling-pot-grill-japanese-shabu-yakiniku-bbq-foothill-ranch"
  },
  {
    "alias": "sofia-wine-bar-new-york"
  },
  {
    "alias": "rsly-redwoods-grill-bar"
  },
  {
    "alias": "dallas-bbq-new-york-7"
  },
  {
    "alias": "rsly-de-cabeza-el-nico"
  },
  {
    "alias": "terzo-san-francisco"
  },
  {
    "alias": "hannas-restaurant-and-bar-rancho-santa-margarita-3"
  },
  {
    "alias": "air-restaurant-lounge-washington"
  },
  {
    "alias": "rsly-tierra-caliente-taqueria-food-truck"
  },
  {
    "alias": "nikki-beach-miami-beach-miami-beach-2"
  },
  {
    "alias": "baker-street-irregulars-new-york"
  },
  {
    "alias": "mr-broadway-new-york"
  },
  {
    "alias": "haidilao-hot-pot-cupertino-cupertino"
  },
  {
    "alias": "uva-new-york"
  },
  {
    "alias": "greek-from-greece-new-york-2"
  },
  {
    "alias": "cotogna-san-francisco"
  },
  {
    "alias": "i-sodi-new-york"
  },
  {
    "alias": "lagos-restaurant-and-lounge-new-york"
  },
  {
    "alias": "buddakan-new-york"
  },
  {
    "alias": "rsly-rotisserie-on-park"
  },
  {
    "alias": "rsly-luke-s-lobster-west-village"
  },
  {
    "alias": "villard-restaurant-new-york"
  },
  {
    "alias": "rsly-soul4realkitchen"
  },
  {
    "alias": "lolas-hoboken"
  },
  {
    "alias": "rsly-thalaiva-s-indian-kitchen-and-bar-prospect-ave"
  },
  {
    "alias": "one65-bistro-and-grill-san-francisco-2"
  },
  {
    "alias": "rsly-savio-s-giant-pizza-deli"
  },
  {
    "alias": "rsly-the-am-thai-williamsburg"
  },
  {
    "alias": "sayola-restaurant-tenafly"
  },
  {
    "alias": "fusion-hk-bar-and-grill-new-york-2"
  },
  {
    "alias": "tian-fu-lou-new-york"
  },
  {
    "alias": "rsly-aris"
  },
  {
    "alias": "rsly-breadbox-pgh"
  },
  {
    "alias": "lavagna-new-york"
  },
  {
    "alias": "the-crosby-bar-new-york"
  },
  {
    "alias": "rsly-crafted-greens"
  },
  {
    "alias": "rsly-tierra-del-sol-mexican-restaurant"
  },
  {
    "alias": "honest-new-york"
  },
  {
    "alias": "gogi-37-new-york"
  },
  {
    "alias": "queensyard-new-york"
  },
  {
    "alias": "pabu-izakaya-san-francisco-san-francisco"
  },
  {
    "alias": "rsly-nice-matin"
  },
  {
    "alias": "renaissance-harlem-new-york"
  },
  {
    "alias": "rsly-rickshaw-pakistani-indian-street-eats"
  },
  {
    "alias": "calista-greek-seafood-taverna-coral-gables"
  },
  {
    "alias": "kazu-sushi-studio-city"
  },
  {
    "alias": "maggies-place-new-york"
  },
  {
    "alias": "silky-kitchen-new-york-5"
  },
  {
    "alias": "nobu-downtown-new-york"
  },
  {
    "alias": "bistro-provence-bethesda"
  },
  {
    "alias": "torrisi-new-york-2"
  },
  {
    "alias": "seoul-new-york"
  },
  {
    "alias": "rsly-nom-mexican-table-tequila-bar"
  },
  {
    "alias": "osteria-mozza-los-angeles"
  },
  {
    "alias": "rsly-drunken-cow-bar-grill"
  },
  {
    "alias": "gekko-miami-3"
  },
  {
    "alias": "sushi-by-boū-nomad-new-york-4"
  },
  {
    "alias": "rsly-zone-28"
  },
  {
    "alias": "dio-deka-los-gatos"
  },
  {
    "alias": "stk-steakhouse-midtown-new-york"
  },
  {
    "alias": "porteno-restaurant-new-york"
  },
  {
    "alias": "rsly-macon-bistro-larder"
  },
  {
    "alias": "rsly-l-allegria-restaurant"
  },
  {
    "alias": "rsly-life-alive-organic-cafe-west-end"
  },
  {
    "alias": "west-side-steakhouse-new-york-2"
  },
  {
    "alias": "deux-amis-new-york"
  },
  {
    "alias": "sushi-sato-san-francisco"
  },
  {
    "alias": "luna-restaurant-jersey-city"
  },
  {
    "alias": "jua-new-york"
  },
  {
    "alias": "bond-45-new-york-2"
  },
  {
    "alias": "kaori-miami"
  },
  {
    "alias": "rsly-rosie-s-trattoria"
  },
  {
    "alias": "kimura-new-york"
  },
  {
    "alias": "gravitas-washington-2"
  },
  {
    "alias": "rsly-barrel-crow"
  },
  {
    "alias": "rsly-anthony-francos-pizza---springfield"
  },
  {
    "alias": "klaw-miami-miami"
  },
  {
    "alias": "sushi-muse-new-york"
  },
  {
    "alias": "deninos-greenwich-village-new-york"
  },
  {
    "alias": "leos-oyster-bar-san-francisco-2"
  },
  {
    "alias": "oyster-riot-old-ebbitt-grill-washington-2"
  },
  {
    "alias": "rsly-mardi-gras-munchies"
  },
  {
    "alias": "alcala-restaurant-new-york"
  },
  {
    "alias": "clement-new-york-13"
  },
  {
    "alias": "brooklyn-chop-house-new-york-3"
  },
  {
    "alias": "paul-martins-american-grill-irvine"
  },
  {
    "alias": "café-luce-new-york"
  },
  {
    "alias": "le-botaniste-new-york-5"
  },
  {
    "alias": "rsly-tita-s-kitchenette"
  },
  {
    "alias": "pazza-notte-new-york-2"
  },
  {
    "alias": "rsly-gladstone-tavern"
  },
  {
    "alias": "maggie-reillys-restaurant-new-york"
  },
  {
    "alias": "sam-sunny-new-york"
  },
  {
    "alias": "the-hero-ranch-kitchen-saratoga-2"
  },
  {
    "alias": "rsly-bar-mercer"
  },
  {
    "alias": "rsly-new-aria-kabab-new-york-city-halal-grill-"
  },
  {
    "alias": "rsly-altoque-cafe"
  },
  {
    "alias": "bar-and-bistro-888-san-francisco"
  },
  {
    "alias": "hinata-san-francisco"
  },
  {
    "alias": "joe-allen-new-york"
  },
  {
    "alias": "izakaya-mew-new-york-3"
  },
  {
    "alias": "fogo-de-chao-coral-gables"
  },
  {
    "alias": "le-coucou-new-york"
  },
  {
    "alias": "villa-mosconi-new-york"
  },
  {
    "alias": "the-craftsman-new-york-2"
  },
  {
    "alias": "le-rivage-new-york-2"
  },
  {
    "alias": "clover-club-brooklyn"
  },
  {
    "alias": "sushi-lab-new-york-5"
  },
  {
    "alias": "rsly-liu-ji-sichuan-noodle-house"
  },
  {
    "alias": "hokey-poké-new-york-2"
  },
  {
    "alias": "cote-korean-steakhouse-new-york"
  },
  {
    "alias": "estiatorio-milos-by-costas-spiliadis-miami-beach"
  },
  {
    "alias": "ruffian-new-york-4"
  },
  {
    "alias": "bevri-palo-alto-palo-alto-2"
  },
  {
    "alias": "noi-due-new-york-2"
  },
  {
    "alias": "american-brass-long-island-city-2"
  },
  {
    "alias": "rsly-mattar-s-bistro"
  },
  {
    "alias": "left-bank-menlo-park-menlo-park"
  },
  {
    "alias": "rsly-mahari"
  },
  {
    "alias": "ocean-prime-washington"
  },
  {
    "alias": "bistro-vendome-new-york"
  },
  {
    "alias": "greca-new-york-5"
  },
  {
    "alias": "domodomo-new-york-new-york-4"
  },
  {
    "alias": "arturos-new-york-5"
  },
  {
    "alias": "il-caffe-latte-new-york-2"
  },
  {
    "alias": "balvanera-new-york-3"
  },
  {
    "alias": "mercado-hollywood-los-angeles"
  },
  {
    "alias": "frida-midtown-new-york"
  },
  {
    "alias": "pascalou-new-york"
  },
  {
    "alias": "jollibee-new-york-2"
  },
  {
    "alias": "rsly-la-piquette"
  },
  {
    "alias": "osa-middletown"
  },
  {
    "alias": "sushi-yuzu-toluca-lake"
  },
  {
    "alias": "rsly-honeygrow"
  },
  {
    "alias": "rsly-mondo-pizza-randolph-nj-"
  },
  {
    "alias": "the-leopard-at-des-artistes-new-york"
  },
  {
    "alias": "redeye-grill-new-york-2"
  },
  {
    "alias": "lets-meat-new-york"
  },
  {
    "alias": "fig-and-olive-new-york-12"
  },
  {
    "alias": "bell-book-and-candle-new-york"
  },
  {
    "alias": "petit-louis-bistro-baltimore"
  },
  {
    "alias": "camper-menlo-park"
  },
  {
    "alias": "rsly-birrieria-de-la-torre"
  },
  {
    "alias": "sparks-steak-house-new-york"
  },
  {
    "alias": "atelier-crenn-san-francisco"
  },
  {
    "alias": "rsly-apple-harvest-catering"
  },
  {
    "alias": "rsly-koma-cafe"
  },
  {
    "alias": "rsly-deniz-mediterranean-cuisine"
  },
  {
    "alias": "sombrero-restaurant-new-york"
  },
  {
    "alias": "pera-soho-new-york"
  },
  {
    "alias": "the-jeffrey-craft-beer-and-bites-new-york"
  },
  {
    "alias": "rsly-the-beast-next-door"
  },
  {
    "alias": "rsly-the-girl-and-the-vine"
  },
  {
    "alias": "sama-street-brooklyn-2"
  },
  {
    "alias": "rsly-industry-public-house"
  },
  {
    "alias": "patrick-steakhouse-brooklyn"
  },
  {
    "alias": "stern-and-bow-closter"
  },
  {
    "alias": "12-chairs-new-york"
  },
  {
    "alias": "rsly-abn-al-sham---"
  },
  {
    "alias": "maritime-parc-jersey-city"
  },
  {
    "alias": "marabu-restaurant-miami"
  },
  {
    "alias": "redemption-nyc-new-york"
  },
  {
    "alias": "washington-prime-south-norwalk"
  },
  {
    "alias": "rsly-nana-good-eats"
  },
  {
    "alias": "rsly-just-friends-cafe"
  },
  {
    "alias": "rsly-cascarino-s"
  },
  {
    "alias": "rsly-russ-daughters-cafe"
  },
  {
    "alias": "scarpetta-new-york"
  },
  {
    "alias": "rsly-poke-house-mueller"
  },
  {
    "alias": "kokomo-brooklyn-2"
  },
  {
    "alias": "nerai-new-york"
  },
  {
    "alias": "rsly-grandpa-tao-kitchen"
  },
  {
    "alias": "bread-n-wine-new-york"
  },
  {
    "alias": "rsly-square-cafe"
  },
  {
    "alias": "saffys-los-angeles-3"
  },
  {
    "alias": "limani-new-york"
  },
  {
    "alias": "sushi-lin-brooklyn-brooklyn-4"
  },
  {
    "alias": "rsly-aura-bar-lounge"
  },
  {
    "alias": "the-palm-washington-dc-washington-2"
  },
  {
    "alias": "rsly-paccis"
  },
  {
    "alias": "rsly-rosemary-bistro-cafe"
  },
  {
    "alias": "pirates-dinner-adventure-buena-park-2"
  },
  {
    "alias": "peter-luger-brooklyn-2"
  },
  {
    "alias": "rsly-scratch-co-"
  },
  {
    "alias": "compagnie-des-vins-surnaturels-new-york-2"
  },
  {
    "alias": "cosima-baltimore"
  },
  {
    "alias": "heirloom-new-haven-2"
  },
  {
    "alias": "felice-15-gold-new-york"
  },
  {
    "alias": "tavola-new-york"
  },
  {
    "alias": "rsly-local-provisions"
  },
  {
    "alias": "rsly-revel"
  },
  {
    "alias": "tenzan-new-york-3"
  },
  {
    "alias": "absinthe-brasserie-and-bar-san-francisco-2"
  },
  {
    "alias": "rsly-taphouse-15"
  },
  {
    "alias": "eighteen-restaurant-new-york-5"
  },
  {
    "alias": "rsly-boon-cafe-fusion-restaurant-"
  },
  {
    "alias": "rsly-flight-club-d-c-"
  },
  {
    "alias": "john-davenports-new-haven"
  },
  {
    "alias": "hanami-japanese-cuisine-new-york"
  },
  {
    "alias": "rsly-arthur-s-tavern"
  },
  {
    "alias": "tír-na-nóg-new-york-14"
  },
  {
    "alias": "the-lafayette-washington-3"
  },
  {
    "alias": "5-o-clock-somewhere-bar-times-square-new-york-2"
  },
  {
    "alias": "shun-lee-palace-new-york"
  },
  {
    "alias": "rsly-5-brothers-taqueria"
  },
  {
    "alias": "ez-paella-and-tapas-new-york-3"
  },
  {
    "alias": "white-horse-tavern-new-york"
  },
  {
    "alias": "common-ground-new-york-7"
  },
  {
    "alias": "upland-new-york"
  },
  {
    "alias": "rsly-fresco-mexican"
  },
  {
    "alias": "merchant-roots-san-francisco"
  },
  {
    "alias": "friendship-bbq-santa-clara"
  },
  {
    "alias": "nellies-sports-bar-washington"
  },
  {
    "alias": "shuka-new-york-3"
  },
  {
    "alias": "rsly-pura-vida-miami"
  },
  {
    "alias": "the-brazen-tavern-new-york"
  },
  {
    "alias": "rsly-carro-cafe-new-jersey"
  },
  {
    "alias": "johns-grill-san-francisco"
  },
  {
    "alias": "blacks-bar-and-kitchen-bethesda"
  },
  {
    "alias": "rsly-the-pluckemin-inn"
  },
  {
    "alias": "rsly-alara"
  },
  {
    "alias": "saint-michaels-alley-palo-alto-2"
  },
  {
    "alias": "fresco-by-scotto-new-york"
  },
  {
    "alias": "lt-steak-and-seafood-miami-beach-2"
  },
  {
    "alias": "the-chelsea-bell-new-york"
  },
  {
    "alias": "rsly-las-delicias-de-triny"
  },
  {
    "alias": "il-falco-long-island-city"
  },
  {
    "alias": "el-nuevo-carribeno-new-york"
  },
  {
    "alias": "rare-steakhouse-and-tavern-washington-3"
  },
  {
    "alias": "dill-and-parsley-new-york-7"
  },
  {
    "alias": "rsly-aoyama-chinese-japanese-cuisine"
  },
  {
    "alias": "josephs-steakhouse-bridgeport"
  },
  {
    "alias": "rsly-dianoia-s-eatery"
  },
  {
    "alias": "chinese-tuxedo-new-york-2"
  },
  {
    "alias": "al-tiramisu-washington"
  },
  {
    "alias": "rsly-martinsville-tavern"
  },
  {
    "alias": "rsly-the-nook"
  },
  {
    "alias": "rsly-mariscos-los-cuates"
  },
  {
    "alias": "faces-and-names-new-york"
  },
  {
    "alias": "masa-new-york"
  },
  {
    "alias": "rsly-the-corner-bistro-nj-"
  },
  {
    "alias": "whitmans-hudson-yards-new-york"
  },
  {
    "alias": "rsly-halal-town-steakhouse-breakfast"
  },
  {
    "alias": "angeletto-restaurant-new-york"
  },
  {
    "alias": "juniors-restaurant-and-bakery-new-york-3"
  },
  {
    "alias": "fire-at-the-ridge-middlefield"
  },
  {
    "alias": "rsly-roger-s-wing"
  },
  {
    "alias": "luce-san-francisco"
  },
  {
    "alias": "ambassador-dining-room-baltimore"
  },
  {
    "alias": "rsly-rh-rooftop-restaurant-at-rh-new-york"
  },
  {
    "alias": "cafe-luxembourg-new-york"
  },
  {
    "alias": "rsly-azure-the-greek-mediterranean"
  },
  {
    "alias": "rsly-farm-fresh-deli-inc"
  },
  {
    "alias": "aita-brooklyn"
  },
  {
    "alias": "ollin-restaurant-new-york"
  },
  {
    "alias": "juban-new-york"
  },
  {
    "alias": "rsly-ron-s-landmark"
  },
  {
    "alias": "kochi-new-york"
  },
  {
    "alias": "sushi-noz-new-york"
  },
  {
    "alias": "madera-menlo-park"
  },
  {
    "alias": "gmt-tavern-new-york"
  },
  {
    "alias": "ravagh-persian-grill-new-york-2"
  },
  {
    "alias": "jean-georges-new-york-2"
  },
  {
    "alias": "true-chesapeake-oyster-baltimore"
  },
  {
    "alias": "benjamin-steakhouse-new-york-city"
  },
  {
    "alias": "adoro-lei-new-york"
  },
  {
    "alias": "el-cielo-by-juan-manuel-barrientos-miami"
  },
  {
    "alias": "the-empire-rooftop-new-york-3"
  },
  {
    "alias": "empire-steak-house-new-york-9"
  },
  {
    "alias": "dirty-french-steakhouse-miami"
  },
  {
    "alias": "rsly-camellias---cocina-brunch"
  },
  {
    "alias": "lobster-place-new-york-4"
  },
  {
    "alias": "tartina-new-york-4"
  },
  {
    "alias": "old-tbilisi-garden-new-york-5"
  },
  {
    "alias": "summit-house-summit"
  },
  {
    "alias": "rsly-black-sesame-rolls"
  },
  {
    "alias": "rouge-studio-city-2"
  },
  {
    "alias": "sip-sak-new-york"
  },
  {
    "alias": "fogo-de-chão-brazilian-steakhouse-baltimore-10"
  },
  {
    "alias": "rsly-plaza-azteca-m-xican-restaurant-white-oak"
  },
  {
    "alias": "rsly-southern-spice"
  },
  {
    "alias": "quatorze-new-york"
  },
  {
    "alias": "rsly-agr-cola-eatery"
  },
  {
    "alias": "the-oceanaire-seafood-room-baltimore"
  },
  {
    "alias": "a-pasta-bar-new-york"
  },
  {
    "alias": "rsly-kitchen234---african-cuisine"
  },
  {
    "alias": "blackwells-pub-and-restaurant-new-york"
  },
  {
    "alias": "carroll-place-new-york"
  },
  {
    "alias": "blacksalt-washington-2"
  },
  {
    "alias": "saru-handroll-bar-san-francisco-2"
  },
  {
    "alias": "rice-kitchen-new-york"
  },
  {
    "alias": "son-and-garden-san-francisco"
  },
  {
    "alias": "rsly-sushi-hana"
  },
  {
    "alias": "rsly-jax-chibugan"
  },
  {
    "alias": "yia-yias-homemade-greek-food-new-york"
  },
  {
    "alias": "maison-sun-brooklyn-5"
  },
  {
    "alias": "rsly-mediterra-cafe-mt-lebanon"
  },
  {
    "alias": "barrow-street-ale-house-new-york"
  },
  {
    "alias": "il-gabbiano-miami"
  },
  {
    "alias": "katana-west-hollywood"
  },
  {
    "alias": "il-mulino-new-york-new-york-8"
  },
  {
    "alias": "acme-new-york"
  },
  {
    "alias": "providence-los-angeles-2"
  },
  {
    "alias": "the-happiest-hour-new-york"
  },
  {
    "alias": "socarrat-paella-bar-nolita-new-york-3"
  },
  {
    "alias": "lenwich-new-york-28"
  },
  {
    "alias": "magdalena-a-maryland-bistro-baltimore"
  },
  {
    "alias": "inday-new-york-5"
  },
  {
    "alias": "ricardo-steak-house-new-york"
  },
  {
    "alias": "meadowsweet-brooklyn"
  },
  {
    "alias": "rsly-chez-oskar"
  },
  {
    "alias": "rsly-dong-bei-upper-west-side-"
  },
  {
    "alias": "rsly-seville-chicago"
  },
  {
    "alias": "slutty-vegan-harlem-new-york"
  },
  {
    "alias": "sistina-new-york"
  },
  {
    "alias": "the-progress-san-francisco-2"
  },
  {
    "alias": "quarterdeck-arlington"
  },
  {
    "alias": "k-minamoto-new-york"
  },
  {
    "alias": "rsly-delicias-latinas"
  },
  {
    "alias": "rsly-blu-blu-greek-kitchen"
  },
  {
    "alias": "sushi-of-gari-uws-gari-columbus-new-york"
  },
  {
    "alias": "indochine-new-york"
  },
  {
    "alias": "barton-g-miami-beach-miami-beach"
  },
  {
    "alias": "rsly-the-alcove"
  },
  {
    "alias": "rsly-johnny-s-reef"
  },
  {
    "alias": "moustache-new-york-9"
  },
  {
    "alias": "rsly-4-jokers-restaurant"
  },
  {
    "alias": "rsly-copper-kettle"
  },
  {
    "alias": "livingston-bagel-livingston"
  },
  {
    "alias": "at-nine-restaurant-and-bar-new-york"
  },
  {
    "alias": "atlantic-grill-new-york-3"
  },
  {
    "alias": "nob-hill-club-san-francisco-5"
  },
  {
    "alias": "ciccio-new-york-11"
  },
  {
    "alias": "rsly-fuddruckers"
  },
  {
    "alias": "chez-josephine-new-york"
  },
  {
    "alias": "lusardis-new-york"
  },
  {
    "alias": "rsly-bocaito"
  },
  {
    "alias": "nai-new-york"
  },
  {
    "alias": "mala-house-new-york"
  },
  {
    "alias": "rsly-las-chicas"
  },
  {
    "alias": "rsly-philly-seafood"
  },
  {
    "alias": "guantanamera-new-york"
  },
  {
    "alias": "maharaja-palace-new-york-2"
  },
  {
    "alias": "rsly-yummy-taste-chinese-restaurant"
  },
  {
    "alias": "noren-izakaya-san-francisco"
  },
  {
    "alias": "cafe-monet-millburn"
  },
  {
    "alias": "rsly-chicken-paradise"
  },
  {
    "alias": "rsly-eleven"
  },
  {
    "alias": "abc-cocina-new-york"
  },
  {
    "alias": "market-table-new-york"
  },
  {
    "alias": "tavira-restaurant-chevy-chase"
  },
  {
    "alias": "romans-brooklyn-3"
  },
  {
    "alias": "rsly-30-burgers---best-burgers-in-new-jersey"
  },
  {
    "alias": "javiers-irvine-irvine"
  },
  {
    "alias": "rsly-catch-cut"
  },
  {
    "alias": "masala-times-greenwich-village-new-york-9"
  },
  {
    "alias": "alidoro-bryant-park-new-york"
  },
  {
    "alias": "giorgios-of-gramercy-new-york"
  },
  {
    "alias": "virgils-real-bbq-new-york-new-york"
  },
  {
    "alias": "rsly-the-occidental"
  },
  {
    "alias": "daffodil-san-francisco"
  },
  {
    "alias": "rsly-roaming-rooster"
  },
  {
    "alias": "crustacean-san-francisco"
  },
  {
    "alias": "nobu-palo-alto-palo-alto"
  },
  {
    "alias": "hutong-new-york"
  },
  {
    "alias": "rsly-seven-fish-cuisine-"
  },
  {
    "alias": "i-ricchi-washington-2"
  },
  {
    "alias": "rpm-italian-washington-4"
  },
  {
    "alias": "rsly-soboku"
  },
  {
    "alias": "kyungbokkung-buena-park-3"
  },
  {
    "alias": "aqua-boil-new-york-2"
  },
  {
    "alias": "vida-verde-new-york"
  },
  {
    "alias": "isohama-new-york"
  },
  {
    "alias": "dolce-italian-miami-beach"
  },
  {
    "alias": "the-commons-chelsea-new-york"
  },
  {
    "alias": "churrascaria-plataforma-new-york-3"
  },
  {
    "alias": "otis-brooklyn-2"
  },
  {
    "alias": "alhambra-washington"
  },
  {
    "alias": "kellari-new-york-new-york"
  },
  {
    "alias": "la-ripaille-new-york"
  },
  {
    "alias": "edwards-steak-house-jersey-city"
  },
  {
    "alias": "sushi-hakko-san-francisco"
  },
  {
    "alias": "hunt-and-fish-club-new-york-2"
  },
  {
    "alias": "sinigual-manhattan-2"
  },
  {
    "alias": "novita-restaurant-new-york"
  },
  {
    "alias": "the-blue-dog-cookhouse-and-bar-new-york"
  },
  {
    "alias": "piccola-cucina-estiatorio-new-york"
  },
  {
    "alias": "annabelle-washington"
  },
  {
    "alias": "rsly-benito-s-trattoria"
  },
  {
    "alias": "mchales-bar-and-grill-new-york"
  },
  {
    "alias": "the-cavalier-san-francisco"
  },
  {
    "alias": "bazár-tapas-bar-and-restaurant-new-york-9"
  },
  {
    "alias": "barn-joo-nomad-new-york-3"
  },
  {
    "alias": "rsly-aromas-of-india"
  },
  {
    "alias": "rsly-tacombi---long-island-city"
  },
  {
    "alias": "che-fico-san-francisco-3"
  },
  {
    "alias": "an-japanese-restaurant-san-francisco-2"
  },
  {
    "alias": "nittis-new-york"
  },
  {
    "alias": "trattoria-pesce-pasta-new-york"
  },
  {
    "alias": "nirvana-grille-laguna-beach"
  },
  {
    "alias": "rsly-amazonia-2nd-floor-causa-1st-floor-"
  },
  {
    "alias": "rsly-feast-gourmet-market-and-eatery"
  },
  {
    "alias": "sidecar-new-york-2"
  },
  {
    "alias": "rsly-imee-s-kitchen"
  },
  {
    "alias": "steak-frites-bistro-new-york-3"
  },
  {
    "alias": "bar-six-new-york"
  },
  {
    "alias": "rsly-conduit-road-public-house"
  },
  {
    "alias": "rsly-the-highwood"
  },
  {
    "alias": "amal-miami"
  },
  {
    "alias": "la-pecora-bianca-new-york-5"
  },
  {
    "alias": "nbhd-new-york"
  },
  {
    "alias": "fresh-basils-trattoria-new-york"
  },
  {
    "alias": "beetle-house-new-york-3"
  },
  {
    "alias": "rsly-old-saigon-vietnamese-bistro"
  },
  {
    "alias": "misi-brooklyn"
  },
  {
    "alias": "rsly-liola"
  },
  {
    "alias": "stiltsville-fish-bar-miami-beach"
  },
  {
    "alias": "oiji-mi-new-york-2"
  },
  {
    "alias": "hyde-sunset-kitchen-cocktails-los-angeles-2"
  },
  {
    "alias": "playwright-celtic-pub-new-york-4"
  },
  {
    "alias": "the-expat-new-york-2"
  },
  {
    "alias": "rsly-grain-house"
  },
  {
    "alias": "rsly-veccia-pizza"
  },
  {
    "alias": "rsly-city-tap-and-grill"
  },
  {
    "alias": "due-new-york"
  },
  {
    "alias": "da-raffaele-new-york"
  },
  {
    "alias": "caravaggio-new-york"
  },
  {
    "alias": "lan-sheng-restaurant-new-york"
  },
  {
    "alias": "plumed-horse-saratoga"
  },
  {
    "alias": "la-pulperia-hells-kitchen-new-york-2"
  },
  {
    "alias": "rsly-sapps"
  },
  {
    "alias": "rsly-cold-friends-kitchen"
  },
  {
    "alias": "rsly-the-tewksbury-inn"
  },
  {
    "alias": "rsly-fuego-y-saz-n"
  },
  {
    "alias": "emporio-new-york"
  },
  {
    "alias": "rsly-domo-7-japanese-restaurant"
  },
  {
    "alias": "rsly-la-peque-a-colombia"
  },
  {
    "alias": "vinatería-harlem"
  },
  {
    "alias": "gossip-bar-and-restaurant-new-york"
  },
  {
    "alias": "pennsylvania-6-nyc-new-york"
  },
  {
    "alias": "casa-madera-west-hollywood-2"
  },
  {
    "alias": "azalea-ristorante-new-york"
  },
  {
    "alias": "rsly-mojitos"
  },
  {
    "alias": "alta-new-york"
  },
  {
    "alias": "harvest-new-haven-2"
  },
  {
    "alias": "rsly-casa-louie"
  },
  {
    "alias": "light-horse-tavern-jersey-city-3"
  },
  {
    "alias": "rsly-papa-johns-pizza"
  },
  {
    "alias": "rsly-sushi-master"
  },
  {
    "alias": "osteria-del-porto-new-york"
  },
  {
    "alias": "blue-ribbon-sushi-bar-and-grill-columbus-circle-new-york-3"
  },
  {
    "alias": "texas-de-brazil-miami-beach-2"
  },
  {
    "alias": "rsly-hometown-bar-b-que"
  },
  {
    "alias": "rsly-hawkers-asian-street-food"
  },
  {
    "alias": "rsly-the-randolph-diner-bar-grill"
  },
  {
    "alias": "tulcingo-restaurant-new-york-3"
  },
  {
    "alias": "rsly-elrama-tavern"
  },
  {
    "alias": "pepe-giallo-new-york"
  },
  {
    "alias": "phillips-seafood-baltimore"
  },
  {
    "alias": "rsly-kaaram"
  },
  {
    "alias": "rsly-dutch-bros-coffee"
  },
  {
    "alias": "rsly-takato"
  },
  {
    "alias": "rsly-bandit-taco"
  },
  {
    "alias": "mediterraneo-restaurant-new-york"
  },
  {
    "alias": "browne-and-co-darien-4"
  },
  {
    "alias": "rsly-newbe-s-sports-bar-grill"
  },
  {
    "alias": "rsly--sauerkraut-fish-"
  },
  {
    "alias": "don-angie-new-york"
  },
  {
    "alias": "pinocchio-restaurant-new-york-3"
  },
  {
    "alias": "rsly-sweet-paris-cr-perie-caf-"
  },
  {
    "alias": "rsly-62-secret-kitchen-"
  },
  {
    "alias": "ra-sushi-times-square-new-york"
  },
  {
    "alias": "souvlaki-gr-midtown-new-york-3"
  },
  {
    "alias": "redfarm-new-york-2"
  },
  {
    "alias": "rsly-green-pear-cafe"
  },
  {
    "alias": "employees-only-new-york"
  },
  {
    "alias": "tomiño-taberna-gallega-new-york"
  },
  {
    "alias": "gemma-new-york"
  },
  {
    "alias": "kanoyama-new-york"
  },
  {
    "alias": "ardesia-new-york"
  },
  {
    "alias": "rsly-halal-pizza-bizza"
  },
  {
    "alias": "ho-ho-kus-inn-and-tavern-ho-ho-kus"
  },
  {
    "alias": "l-amico-nyc-new-york"
  },
  {
    "alias": "temple-court-new-york"
  },
  {
    "alias": "sushi-kaito-new-york"
  },
  {
    "alias": "rsly-lolev-beer"
  },
  {
    "alias": "rsly-canto-west-village"
  },
  {
    "alias": "ushiwakamaru-new-york-4"
  },
  {
    "alias": "the-wilson-nyc-new-york-2"
  },
  {
    "alias": "rsly-kajiken-alexandria"
  },
  {
    "alias": "rsly-taqueria-jefes"
  },
  {
    "alias": "convivium-osteria-brooklyn"
  },
  {
    "alias": "sfoglia-restaurant-new-york"
  },
  {
    "alias": "india-at-time-square-new-york"
  },
  {
    "alias": "strip-house-new-york-6"
  },
  {
    "alias": "rsly-takumen"
  },
  {
    "alias": "shang-cafe-san-jose-3"
  },
  {
    "alias": "o-donoghues-pub-new-york"
  },
  {
    "alias": "rsly-kabab-ghar-austin"
  },
  {
    "alias": "rsly-cocoluxe-fine-pastries"
  },
  {
    "alias": "fuji-hibachi-new-york-3"
  },
  {
    "alias": "birdland-new-york-2"
  },
  {
    "alias": "le-monde-new-york-6"
  },
  {
    "alias": "the-magic-castle-hollywood"
  },
  {
    "alias": "buenos-aires-restaurant-new-york-2"
  },
  {
    "alias": "katsuya-hollywood-los-angeles-2"
  },
  {
    "alias": "rsly-664-tj-birrieria"
  },
  {
    "alias": "rsly-el-chivito-d-oro"
  },
  {
    "alias": "osteria-57-new-york"
  },
  {
    "alias": "rsly-1776-morristown"
  },
  {
    "alias": "rsly-charming-sichuan"
  },
  {
    "alias": "butcher-bros-steakhouse-cheshire-2"
  },
  {
    "alias": "the-spaniard-new-york"
  },
  {
    "alias": "le-marais-new-york"
  },
  {
    "alias": "rsly-nox-s-tavern-grille"
  },
  {
    "alias": "rsly-g-s-on-liberty"
  },
  {
    "alias": "kahlo-new-york"
  },
  {
    "alias": "fogo-de-chao-san-francisco-san-francisco-2"
  },
  {
    "alias": "ristorante-la-perla-of-washington-washington-3"
  },
  {
    "alias": "anytime-kitchen-new-york-2"
  },
  {
    "alias": "i-can-barbecue-korean-grill-irvine-irvine"
  },
  {
    "alias": "lucky-chengs-new-york-3"
  },
  {
    "alias": "long-acre-tavern-new-york-3"
  },
  {
    "alias": "august-gatherings-new-york-2"
  },
  {
    "alias": "yes-apothecary-new-york-4"
  },
  {
    "alias": "sant-ambroeus-new-york"
  },
  {
    "alias": "korean-spring-bbq-santa-clara"
  },
  {
    "alias": "rsly-bad-ass-coffee-of-hawaii"
  },
  {
    "alias": "the-river-café-brooklyn-3"
  },
  {
    "alias": "boqueria-flatiron-new-york-4"
  },
  {
    "alias": "rsly-patria-station-caf-"
  },
  {
    "alias": "fire-and-oak-jersey-city-jersey-city-2"
  },
  {
    "alias": "ayce-sushi-hb-huntington-beach-3"
  },
  {
    "alias": "sushi-yasuda-new-york"
  },
  {
    "alias": "rsly-duo-s"
  },
  {
    "alias": "coppelia-new-york"
  },
  {
    "alias": "il-bastardo-new-york-4"
  },
  {
    "alias": "ariete-miami-2"
  },
  {
    "alias": "grand-tier-restaurant-new-york-2"
  },
  {
    "alias": "xian-famous-foods-new-york-40"
  },
  {
    "alias": "luxor-lounge-new-york"
  },
  {
    "alias": "junoon-new-york"
  },
  {
    "alias": "nica-trattoria-new-york"
  },
  {
    "alias": "rsly-fish-with-you-"
  },
  {
    "alias": "little-thai-kitchen-new-york"
  },
  {
    "alias": "macchialina-taverna-rustica-miami-beach"
  },
  {
    "alias": "rsly-eighth-hays"
  },
  {
    "alias": "rsly-planta"
  },
  {
    "alias": "rsly-tarbosh-mediterranean-restaurant"
  },
  {
    "alias": "amata-new-york-2"
  },
  {
    "alias": "rsly-gulp-"
  },
  {
    "alias": "rsly-luigis-pizza"
  },
  {
    "alias": "left-bank-new-york"
  },
  {
    "alias": "central-market-new-york-new-york-5"
  },
  {
    "alias": "toloache-50-new-york"
  },
  {
    "alias": "rsly-dorothy-6"
  },
  {
    "alias": "donna-margherita-new-york"
  },
  {
    "alias": "ristorante-milano-san-francisco"
  },
  {
    "alias": "rsly-bhc-chicken-rancho-bernardo"
  },
  {
    "alias": "the-standard-grill-new-york-3"
  },
  {
    "alias": "rsly-conway-diner"
  },
  {
    "alias": "landmark-tavern-new-york-2"
  },
  {
    "alias": "salt-arlington"
  },
  {
    "alias": "secchu-yokota-new-york"
  },
  {
    "alias": "swing-46-new-york-2"
  },
  {
    "alias": "naya-mezze-and-grill-new-york"
  },
  {
    "alias": "rsly-orgovia"
  },
  {
    "alias": "meskerem-ethiopian-cuisine-new-york"
  },
  {
    "alias": "poulette-rotisserie-new-york-2"
  },
  {
    "alias": "rsly-his-hers"
  },
  {
    "alias": "rsly-eat-tokyo"
  },
  {
    "alias": "antica-ristorante-new-york"
  },
  {
    "alias": "rsly-el-riqui-mariscos-de-carreta"
  },
  {
    "alias": "bottino-new-york"
  },
  {
    "alias": "katana-kitten-new-york-2"
  },
  {
    "alias": "rsly-city-sweets-"
  },
  {
    "alias": "gelsons-irvine-3"
  },
  {
    "alias": "barano-brooklyn"
  },
  {
    "alias": "rsly-rosedale-restaurant"
  },
  {
    "alias": "gregorios-chatham"
  },
  {
    "alias": "rsly-coquito-blu"
  },
  {
    "alias": "negril-village-new-york"
  },
  {
    "alias": "rsly-rocco-s"
  },
  {
    "alias": "marea-new-york"
  },
  {
    "alias": "le-diplomate-washington"
  },
  {
    "alias": "rsly-frenchette"
  },
  {
    "alias": "carmines-italian-restaurant-washington-washington-4"
  },
  {
    "alias": "wonder-pig-kbbq-long-island-city"
  },
  {
    "alias": "rsly-oishii-donburi"
  },
  {
    "alias": "pera-mediterranean-brasserie-new-york"
  },
  {
    "alias": "rsly-saffron-street"
  },
  {
    "alias": "american-cut-steakhouse-tribeca-new-york"
  },
  {
    "alias": "black-walnut-brooklyn-2"
  },
  {
    "alias": "flowers-saratoga-saratoga-2"
  },
  {
    "alias": "henrys-end-brooklyn-4"
  },
  {
    "alias": "niu-kitchen-miami"
  },
  {
    "alias": "rsly-nohu-rooftop-bar-restaurant"
  },
  {
    "alias": "madre-brooklyn-2"
  },
  {
    "alias": "rt60-new-york"
  },
  {
    "alias": "butcher-and-banker-new-york-3"
  },
  {
    "alias": "the-django-new-york"
  },
  {
    "alias": "hello-saigon-new-york"
  },
  {
    "alias": "the-bombay-club-washington"
  },
  {
    "alias": "lux-restaurant-los-angeles"
  },
  {
    "alias": "imli-urban-indian-food-new-york-3"
  },
  {
    "alias": "yank-sing-san-francisco"
  },
  {
    "alias": "clay-new-york-3"
  },
  {
    "alias": "rsly-bstro-38"
  },
  {
    "alias": "rsly-mighty-oak-barrel"
  },
  {
    "alias": "antoya-korean-bbq-new-york"
  },
  {
    "alias": "cowgirl-new-york"
  },
  {
    "alias": "merois-west-hollywood"
  },
  {
    "alias": "rsly-chipotle-mexican-grill"
  },
  {
    "alias": "leitao-new-york-3"
  },
  {
    "alias": "rsly-nai-brother-sauerkraut-fish-columbia-university-"
  },
  {
    "alias": "rsly-47th-street-summertime-cantina"
  },
  {
    "alias": "kubeh-new-york-2"
  },
  {
    "alias": "rsly-z-eats-formerly-zoup-"
  },
  {
    "alias": "rsly-little-beast-cafe-bistro"
  },
  {
    "alias": "rsly-tsuki-japanese-restaurant"
  },
  {
    "alias": "rsly-seoul-food-d-c-"
  },
  {
    "alias": "rsly-el-coyote"
  },
  {
    "alias": "ai-ki-ya-new-york-3"
  },
  {
    "alias": "lupa-new-york"
  },
  {
    "alias": "da-long-yi-hot-pot-long-island-city"
  },
  {
    "alias": "rsly-yella-s"
  },
  {
    "alias": "rsly-buca-di-beppo-italian-restaurant"
  },
  {
    "alias": "cascalote-latin-bistro-new-york"
  },
  {
    "alias": "la-nacional-new-york-6"
  },
  {
    "alias": "cipriani-new-york-2"
  },
  {
    "alias": "sams-grill-and-seafood-restaurant-san-francisco"
  },
  {
    "alias": "luna-del-sea-steak-and-seafood-bistro-baltimore-2"
  },
  {
    "alias": "momokawa-new-york-2"
  },
  {
    "alias": "rsly-kindling-downtown-cookout-cocktails"
  },
  {
    "alias": "ko-sushi-new-york-4"
  },
  {
    "alias": "officina-washington"
  },
  {
    "alias": "cara-mia-millburn"
  },
  {
    "alias": "barolo-east-new-york"
  },
  {
    "alias": "rsly-chaykhana-pittsburgh"
  },
  {
    "alias": "serafina-italian-restaurant-meatpacking-new-york"
  },
  {
    "alias": "the-picnic-basket-new-york"
  },
  {
    "alias": "little-kirin-new-york"
  },
  {
    "alias": "rsly-gou-gou-pizza---playas"
  },
  {
    "alias": "towa-new-york-3"
  },
  {
    "alias": "bar-54-new-york-2"
  },
  {
    "alias": "nialls-new-york"
  },
  {
    "alias": "turkish-cuisine-new-york"
  },
  {
    "alias": "nm-cafe-short-hills"
  },
  {
    "alias": "legasea-bar-and-grill-new-york"
  },
  {
    "alias": "rsly-little-caesars-pizza"
  },
  {
    "alias": "cafe-d-alsace-new-york-5"
  },
  {
    "alias": "mytango-menlo-park"
  },
  {
    "alias": "rsly-gimme-more-thai"
  },
  {
    "alias": "rsly-otaru-japanese-restaurant-pittsburgh"
  },
  {
    "alias": "rsly-fish-chix"
  },
  {
    "alias": "noodies-new-york"
  },
  {
    "alias": "l-accolade-new-york"
  },
  {
    "alias": "rsly-the-crack-shack---pacific-beach"
  },
  {
    "alias": "myers-of-keswick-new-york"
  },
  {
    "alias": "equinox-restaurant-washington-2"
  },
  {
    "alias": "rowayton-market-norwalk"
  },
  {
    "alias": "marseille-new-york"
  },
  {
    "alias": "rsly-los-gallitos-taqueria"
  },
  {
    "alias": "rsly-the-buffs"
  },
  {
    "alias": "zaytinya-washington"
  },
  {
    "alias": "harrys-new-york-3"
  },
  {
    "alias": "rsly-bistro-aracosia"
  },
  {
    "alias": "rsly-rose-s-kitchen-e-slaughter"
  },
  {
    "alias": "rsly-pennyroyal-station"
  },
  {
    "alias": "rsly-eat-seafood---times-square"
  },
  {
    "alias": "rsly-ristorante-mv"
  },
  {
    "alias": "rsly-martha-s"
  },
  {
    "alias": "bryant-park-grill-new-york-3"
  },
  {
    "alias": "the-pink-elephant-san-francisco-5"
  },
  {
    "alias": "tosca-cafe-san-francisco-3"
  },
  {
    "alias": "rsly-crevette"
  },
  {
    "alias": "faun-brooklyn"
  },
  {
    "alias": "tios-bistro-new-york"
  },
  {
    "alias": "telefèric-barcelona-palo-alto-palo-alto"
  },
  {
    "alias": "soho-sushi-new-york"
  },
  {
    "alias": "pastis-new-york-3"
  },
  {
    "alias": "la-diagonal-new-york-5"
  },
  {
    "alias": "emily-west-village-new-york"
  },
  {
    "alias": "island-new-york-2"
  },
  {
    "alias": "while-we-were-young-new-york"
  },
  {
    "alias": "turks-and-frogs-new-york"
  },
  {
    "alias": "sings-deli-and-grocery-new-york"
  },
  {
    "alias": "district-local-new-york-2"
  },
  {
    "alias": "serendipity-3-new-york"
  },
  {
    "alias": "the-edge-harlem-new-york"
  },
  {
    "alias": "rsly-shimiaodao-yunnan-rice-noodles-tijuana-"
  },
  {
    "alias": "nespresso-boutique-at-bloomingdales-short-hills"
  },
  {
    "alias": "crepe-master-new-york-7"
  },
  {
    "alias": "mémé-mediterranean-new-york-12"
  },
  {
    "alias": "hometown-hotpot-and-bbq-new-york-2"
  },
  {
    "alias": "seven-reasons-washington"
  },
  {
    "alias": "bocca-di-bacco-hells-kitchen-new-york"
  },
  {
    "alias": "sweet-catch-new-york"
  },
  {
    "alias": "ocabanon-new-york"
  },
  {
    "alias": "palo-santo-brooklyn"
  },
  {
    "alias": "épernay-bistro-los-gatos"
  },
  {
    "alias": "acquerello-san-francisco"
  },
  {
    "alias": "rsly-colonial-pantry"
  },
  {
    "alias": "brasserie-memere-closter-2"
  },
  {
    "alias": "toscana-49-new-york"
  },
  {
    "alias": "smoke-house-restaurant-burbank-3"
  },
  {
    "alias": "rsly-nonna-delia-s"
  },
  {
    "alias": "il-cantinori-new-york"
  },
  {
    "alias": "electric-lemon-new-york"
  },
  {
    "alias": "chola-new-york-3"
  },
  {
    "alias": "savoi-latin-bistro-brooklyn-2"
  },
  {
    "alias": "rsly-spanglish-nyc-astoria"
  },
  {
    "alias": "hiyake-omakase-new-york"
  },
  {
    "alias": "toloache-82nd-new-york"
  },
  {
    "alias": "rsly-the-colonial-grill"
  },
  {
    "alias": "porto-leggero-jersey-city"
  },
  {
    "alias": "abyssinia-ethiopian-restaurant-new-york"
  },
  {
    "alias": "dukunoo-miami-3"
  },
  {
    "alias": "ala-washington"
  },
  {
    "alias": "casa-tua-miami-beach"
  },
  {
    "alias": "kjun-new-york"
  },
  {
    "alias": "bobby-vans-steakhouse-new-york-12"
  },
  {
    "alias": "laurel-court-restaurant-and-bar-san-francisco-4"
  },
  {
    "alias": "piccola-cucina-osteria-new-york-2"
  },
  {
    "alias": "el-kallejon-new-york"
  },
  {
    "alias": "ninos-46-new-york"
  },
  {
    "alias": "rsly-the-parlor-pizza-kitchen-whitestone"
  },
  {
    "alias": "tao-downtown-restaurant-new-york-city"
  },
  {
    "alias": "rsly-savs-deli-convenience-store"
  },
  {
    "alias": "rsly-in-session-sound-bite-lounge"
  },
  {
    "alias": "knickerbocker-bar-and-grill-new-york"
  },
  {
    "alias": "cosmos-club-washington"
  },
  {
    "alias": "rsly-trattoria-mediterranea"
  },
  {
    "alias": "rsly-bella-sicilia-pizzeria"
  },
  {
    "alias": "rsly-rogue-bbq"
  },
  {
    "alias": "osso-steakhouse-san-francisco"
  },
  {
    "alias": "rsly-nancettas-ristorante"
  },
  {
    "alias": "foxy-johns-bar-and-kitchen-new-york"
  },
  {
    "alias": "restaurant-anzu-san-francisco-7"
  },
  {
    "alias": "eight-tables-by-george-chen-san-francisco"
  },
  {
    "alias": "jaleo-by-josé-andrés-washington"
  },
  {
    "alias": "toledo-restaurant-new-york"
  },
  {
    "alias": "ichiran-midtown-new-york"
  },
  {
    "alias": "takara-14-washington"
  },
  {
    "alias": "rsly-verde-ristorante"
  },
  {
    "alias": "rsly-eli-s-eatery"
  },
  {
    "alias": "shalom-japan-brooklyn"
  },
  {
    "alias": "estela-new-york-2"
  },
  {
    "alias": "rsly-son-cubano-modern-cuban-cuisine"
  },
  {
    "alias": "rsly-grato"
  },
  {
    "alias": "maison-premiere-brooklyn"
  },
  {
    "alias": "rsly-gladstone-market"
  },
  {
    "alias": "the-waterfront-restaurant-san-francisco-5"
  },
  {
    "alias": "joes-seafood-prime-steak-and-stone-crab-washington"
  },
  {
    "alias": "victory-restaurant-and-lounge-miami-2"
  },
  {
    "alias": "rsly-bistro-seven-three"
  },
  {
    "alias": "lifethyme-new-york"
  },
  {
    "alias": "the-russian-tea-room-new-york"
  },
  {
    "alias": "nizza-new-york"
  },
  {
    "alias": "rsly-pitts-halal-brothers"
  },
  {
    "alias": "kyosho-menlo-park-5"
  },
  {
    "alias": "rsly-julieat-s-bubble-tea-dessert-cafe"
  },
  {
    "alias": "rsly-tupelo-honey-southern-kitchen-bar"
  },
  {
    "alias": "5a5-steak-lounge-san-francisco-4"
  },
  {
    "alias": "rsly-indian-street-food-by-tawakkul"
  },
  {
    "alias": "rsly-blue-cafe"
  },
  {
    "alias": "sukhumvit-51-new-york"
  },
  {
    "alias": "forbes-mill-steakhouse-los-gatos"
  },
  {
    "alias": "stella-34-trattoria-new-york"
  },
  {
    "alias": "un-plaza-grill-new-york"
  },
  {
    "alias": "rsly-westville-hudson"
  },
  {
    "alias": "tail-up-goat-washington"
  },
  {
    "alias": "houseman-new-york"
  },
  {
    "alias": "suprema-provisions-new-york"
  },
  {
    "alias": "rsly-the-meltdown"
  },
  {
    "alias": "the-folly-new-york"
  },
  {
    "alias": "boutros-brooklyn"
  },
  {
    "alias": "bedford-cheese-shop-new-york"
  },
  {
    "alias": "rsly-singas-famous-pizza"
  },
  {
    "alias": "rsly-echo-tap-grille"
  },
  {
    "alias": "connollys-pub-and-restaurant-new-york"
  },
  {
    "alias": "butter-midtown-new-york"
  },
  {
    "alias": "taberna-del-alabardero-washington"
  },
  {
    "alias": "rsly-tokyo-ramen"
  },
  {
    "alias": "rsly-a-legna-wood-fired-pizza-italian-cuisine"
  },
  {
    "alias": "olives-new-york-3"
  },
  {
    "alias": "jue-lan-club-new-york-3"
  },
  {
    "alias": "amélie-new-york"
  },
  {
    "alias": "ristorante-tosca-washington"
  },
  {
    "alias": "juku-new-york"
  },
  {
    "alias": "rsly-claire-s-wine-bar"
  },
  {
    "alias": "rsly-cafe-adirondack-restaurant-wine-room"
  },
  {
    "alias": "come-prima-ristorante-new-york-2"
  },
  {
    "alias": "rsly-oceanic-boil---jackson-heights"
  },
  {
    "alias": "il-corso-new-york"
  },
  {
    "alias": "rsly-table-42"
  },
  {
    "alias": "luce-restaurant-middletown"
  },
  {
    "alias": "peasant-new-york"
  },
  {
    "alias": "hilda-and-jesse-san-francisco"
  },
  {
    "alias": "the-prime-rib-baltimore"
  },
  {
    "alias": "nocello-new-york"
  },
  {
    "alias": "empress-by-boon-san-francisco"
  },
  {
    "alias": "harlem-seafood-soul-new-york"
  },
  {
    "alias": "al-di-la-trattoria-brooklyn"
  },
  {
    "alias": "rsly-piccolo-forno"
  },
  {
    "alias": "benoit-new-york"
  },
  {
    "alias": "bierhaus-nyc-new-york-4"
  },
  {
    "alias": "art-and-soul-washington-2"
  },
  {
    "alias": "rusty-scupper-baltimore"
  },
  {
    "alias": "rsly-the-outpost-mexican-eatery"
  },
  {
    "alias": "rsly-brick-and-barrel-cross-keys"
  },
  {
    "alias": "off-the-record-washington"
  },
  {
    "alias": "viceversa-new-york"
  },
  {
    "alias": "rsly-il-sole"
  },
  {
    "alias": "rsly-mansa-kunda-restaurant"
  },
  {
    "alias": "blue-ribbon-brasserie-soho-new-york"
  },
  {
    "alias": "felice-83-new-york"
  },
  {
    "alias": "herbs-thai-bistro-new-york-2"
  },
  {
    "alias": "rsly-croissant-bakery-restaurant"
  },
  {
    "alias": "rsly-stage-house-tavern"
  },
  {
    "alias": "rsly-gotan-weehawken"
  },
  {
    "alias": "house-of-prime-rib-san-francisco"
  },
  {
    "alias": "rsly-inca-paisa"
  },
  {
    "alias": "rsly-el-neg-o-taco-shop"
  },
  {
    "alias": "croton-reservoir-tavern-new-york"
  },
  {
    "alias": "jora-restaurant-and-bar-long-island-city"
  },
  {
    "alias": "teds-montana-grill-new-york-new-york"
  },
  {
    "alias": "the-ear-inn-new-york"
  },
  {
    "alias": "yakiniku-futago-new-york"
  },
  {
    "alias": "rsly-stonewood-tavern"
  },
  {
    "alias": "tre-scalini-restaurant-new-haven"
  },
  {
    "alias": "aldo-sohm-wine-bar-new-york"
  },
  {
    "alias": "rsly-miza"
  },
  {
    "alias": "rsly-howoo"
  },
  {
    "alias": "bresca-washington"
  },
  {
    "alias": "rsly-dinah-s-comfort-kitchen"
  },
  {
    "alias": "mortons-the-steakhouse-washington-3"
  },
  {
    "alias": "kiku-alpine-restaurant-alpine"
  },
  {
    "alias": "kaoru-new-york"
  },
  {
    "alias": "article-one-lounge-washington"
  },
  {
    "alias": "rsly-arepa-pa-los-pana-inc-"
  },
  {
    "alias": "rsly-opal"
  },
  {
    "alias": "rsly-arepa-lady"
  },
  {
    "alias": "rsly-longhorn-steakhouse"
  },
  {
    "alias": "l-antica-pizzeria-da-michele-new-york"
  },
  {
    "alias": "rsly-osteria-nonnino"
  },
  {
    "alias": "rsly-cracker-barrel-old-country-store"
  },
  {
    "alias": "the-vault-garden-san-francisco-2"
  },
  {
    "alias": "rsly-crave-mediterranean-grill"
  },
  {
    "alias": "rsly-blue-road-burger"
  },
  {
    "alias": "harbor-harvest-norwalk"
  },
  {
    "alias": "rsly-coniglio-s-old-fashioned"
  },
  {
    "alias": "zola-barzola-palo-alto-2"
  },
  {
    "alias": "rsly-nyame-ye-african-and-caribbean-restaurant"
  },
  {
    "alias": "rsly-l-l-hawaiian-barbecue"
  },
  {
    "alias": "kiki-miami"
  },
  {
    "alias": "vestry-new-york"
  },
  {
    "alias": "roots-steakhouse-summit"
  },
  {
    "alias": "rsly-taqueria-monarca"
  },
  {
    "alias": "daniel-new-york-4"
  },
  {
    "alias": "bad-roman-new-york"
  },
  {
    "alias": "the-melting-pot-arlington-5"
  },
  {
    "alias": "rsly-duke-s-upper-deck-cafe"
  },
  {
    "alias": "amity-hall-downtown-new-york"
  },
  {
    "alias": "rsly-love-lamp-matcha"
  },
  {
    "alias": "panda-harlem-new-york-2"
  },
  {
    "alias": "union-square-cafe-new-york-8"
  },
  {
    "alias": "estiatorio-milos-new-york-3"
  },
  {
    "alias": "becco-new-york-4"
  },
  {
    "alias": "rsly-tra-di-noi"
  },
  {
    "alias": "azabu-miami-beach-miami-beach-2"
  },
  {
    "alias": "kinship-washington"
  },
  {
    "alias": "rsly-flavors-of-india"
  },
  {
    "alias": "rsly-double-ma-la-tang"
  },
  {
    "alias": "gabriel-kreuther-new-york"
  },
  {
    "alias": "fleming-s-prime-steakhouse-and-wine-bar-coral-gables-3"
  },
  {
    "alias": "alexanders-steakhouse-cupertino-11"
  },
  {
    "alias": "bondi-new-york-2"
  },
  {
    "alias": "blade-miami-beach-2"
  },
  {
    "alias": "palace-restaurant-new-york"
  },
  {
    "alias": "blue-ribbon-sushi-new-york"
  },
  {
    "alias": "dan-and-brads-arlington"
  },
  {
    "alias": "rsly-the-vandal"
  },
  {
    "alias": "cir-lounge-fountain-valley"
  },
  {
    "alias": "raos-new-york"
  },
  {
    "alias": "non-solo-piada-new-york"
  },
  {
    "alias": "mole-new-york-3"
  },
  {
    "alias": "malatesta-trattoria-new-york"
  },
  {
    "alias": "la-fondue-saratoga"
  },
  {
    "alias": "hot-jalapeño-new-york-2"
  },
  {
    "alias": "arno-ristorante-new-york"
  },
  {
    "alias": "carbone-miami-miami-beach"
  },
  {
    "alias": "jakes-the-knick-new-york"
  },
  {
    "alias": "serena-rooftop-miami-beach"
  },
  {
    "alias": "rsly-chef-trini-s-restaurant"
  },
  {
    "alias": "rsly-guac-time-mexican-grill"
  },
  {
    "alias": "urban-vegan-kitchen-new-york"
  },
  {
    "alias": "rsly-ping-yang"
  },
  {
    "alias": "riverwalk-cafe-miami"
  },
  {
    "alias": "rsly-halal-cajun-platters"
  },
  {
    "alias": "nowon-east-village-new-york-3"
  },
  {
    "alias": "mr-t-los-angeles"
  },
  {
    "alias": "wu-liang-ye-new-york"
  },
  {
    "alias": "matsunori-new-york"
  },
  {
    "alias": "trattoria-dellarte-new-york"
  },
  {
    "alias": "rsly-the-blossom-cafe"
  },
  {
    "alias": "mele-bistro-arlington-3"
  },
  {
    "alias": "koloman-new-york-2"
  },
  {
    "alias": "kings-of-kobe-new-york-8"
  },
  {
    "alias": "los-fuegos-by-francis-mallmann-miami-beach-2"
  },
  {
    "alias": "sawa-sushi-sunnyvale"
  },
  {
    "alias": "rsly-mister-tiger"
  },
  {
    "alias": "rsly-cuban-breeze"
  },
  {
    "alias": "rsly-buckboard-s-bbq-brew"
  },
  {
    "alias": "rsly-olive-lounge-grill"
  },
  {
    "alias": "ouzo-bay-baltimore"
  },
  {
    "alias": "forsythia-new-york-3"
  },
  {
    "alias": "fiddlesticks-pub-new-york"
  },
  {
    "alias": "rsly-bedminster-pizza"
  },
  {
    "alias": "rsly-life-after-restaurant-lounge"
  },
  {
    "alias": "rsly-gyroland-and-bakery"
  },
  {
    "alias": "karma-modern-indian-washington-2"
  },
  {
    "alias": "suki-new-york-5"
  },
  {
    "alias": "rsly-dumpling-district"
  },
  {
    "alias": "rsly-kyuramen---forest-hills"
  },
  {
    "alias": "moonstruck-eatery-new-york-2"
  },
  {
    "alias": "charleston-baltimore"
  },
  {
    "alias": "rsly-seoul-tofu"
  },
  {
    "alias": "san-pietro-new-york"
  },
  {
    "alias": "rsly-d-antigua-restaurant-bar"
  },
  {
    "alias": "rsly-picante-the-taste-of-mexico"
  },
  {
    "alias": "rsly-mekin-thaifood"
  },
  {
    "alias": "parker-and-quinn-new-york"
  },
  {
    "alias": "da-long-yi-hot-pot-new-york-4"
  },
  {
    "alias": "benihibachi-japanese-grill-los-angeles-4"
  },
  {
    "alias": "rsly-la-strada-restaurant"
  },
  {
    "alias": "r40-long-island-city-2"
  },
  {
    "alias": "rsly-blu-on-the-hudson"
  },
  {
    "alias": "rsly-dave-s-hot-chicken"
  },
  {
    "alias": "stoney-river-towson"
  },
  {
    "alias": "pisticci-new-york"
  },
  {
    "alias": "scottadito-osteria-toscana-brooklyn"
  },
  {
    "alias": "the-greek-new-york-2"
  },
  {
    "alias": "the-independent-new-york-3"
  },
  {
    "alias": "rsly-bubbakoo-s-burritos"
  },
  {
    "alias": "llama-san-new-york-4"
  },
  {
    "alias": "minar-kabab-tikka-corner-jersey-city-2"
  },
  {
    "alias": "rsly-seasons-52"
  },
  {
    "alias": "gardenia-terrace-new-york"
  },
  {
    "alias": "fig-and-olive-new-york-10"
  },
  {
    "alias": "gelsons-hollywood-2"
  },
  {
    "alias": "rsly-ta-rica-cuban-food"
  },
  {
    "alias": "rsly-mabu-generation"
  },
  {
    "alias": "luna-rossa-new-york"
  },
  {
    "alias": "semma-new-york-2"
  },
  {
    "alias": "the-biergarten-at-the-standard-high-line-new-york"
  },
  {
    "alias": "the-chelsea-fairfield"
  },
  {
    "alias": "3-sheets-new-york"
  },
  {
    "alias": "rsly-cozy-corner-restaurant-and-pancake-house"
  },
  {
    "alias": "marco-polo-ristorante-brooklyn"
  },
  {
    "alias": "rsly-sapori-d-italia"
  },
  {
    "alias": "fonda-tribeca-new-york-4"
  },
  {
    "alias": "cafe-fiorello-new-york"
  },
  {
    "alias": "rsly-uncle-peter-s"
  },
  {
    "alias": "rsly-la-rienda-cafe"
  },
  {
    "alias": "rsly-beanbury-coffee-kitchen"
  },
  {
    "alias": "red-hook-tavern-brooklyn"
  },
  {
    "alias": "the-musket-room-new-york"
  },
  {
    "alias": "ilili-new-york-2"
  },
  {
    "alias": "bowery-road-new-york-3"
  },
  {
    "alias": "rsly-bass-bourbon"
  },
  {
    "alias": "greens-restaurant-san-francisco-5"
  },
  {
    "alias": "blue-martini-lounge-miami"
  },
  {
    "alias": "settepani-new-york-5"
  },
  {
    "alias": "orso-new-york"
  },
  {
    "alias": "rsly-s2-express-grill-downtown"
  },
  {
    "alias": "rsly-little-thailand"
  },
  {
    "alias": "santiagos-beer-garden-new-york"
  },
  {
    "alias": "amaze-new-york"
  },
  {
    "alias": "gary-danko-san-francisco"
  },
  {
    "alias": "mari-new-york-2"
  },
  {
    "alias": "rsly-the-station"
  },
  {
    "alias": "chungdam-santa-clara"
  },
  {
    "alias": "rsly-chuy-s"
  },
  {
    "alias": "rsly-bb-q-chicken-national-city"
  },
  {
    "alias": "rsly-nash-smashed"
  },
  {
    "alias": "makana-hawaiian-and-japanese-bbq-new-york"
  },
  {
    "alias": "lido-bayside-grill-miami-beach"
  },
  {
    "alias": "boxwood-at-the-london-west-hollywood"
  },
  {
    "alias": "st-pats-bar-and-grill-new-york"
  },
  {
    "alias": "rsly-giuseppe-s-trattoria"
  },
  {
    "alias": "rsly-j-gerhaus"
  },
  {
    "alias": "rsly-sree-s-foods"
  },
  {
    "alias": "serafina-italian-restaurant-tribeca-new-york"
  },
  {
    "alias": "berimbau-brazilian-kitchen-new-york-2"
  },
  {
    "alias": "destefanos-steakhouse-brooklyn"
  },
  {
    "alias": "uva-next-door-new-york-4"
  },
  {
    "alias": "queen-miami-beach-miami-beach"
  },
  {
    "alias": "rsly-3321-bistro-dc"
  },
  {
    "alias": "rsly-tigerone-express"
  },
  {
    "alias": "osamil-new-york"
  },
  {
    "alias": "rsly-chesapeake-tavern"
  },
  {
    "alias": "one-if-by-land-two-if-by-sea-new-york"
  },
  {
    "alias": "rsly-donghai"
  },
  {
    "alias": "rsly-taste-point-dim-sum-house"
  },
  {
    "alias": "murphys-law-new-york"
  },
  {
    "alias": "sato-omakase-san-francisco"
  },
  {
    "alias": "the-dolar-shop-new-york"
  },
  {
    "alias": "nightbird-san-francisco"
  },
  {
    "alias": "rsly-raffi-s-locale"
  },
  {
    "alias": "axia-taverna-tenafly"
  },
  {
    "alias": "rsly-enzo-restaurant-pizzeria"
  },
  {
    "alias": "salinas-new-york"
  },
  {
    "alias": "rsly-muldoon-s"
  },
  {
    "alias": "kissaki-sushi-new-york"
  },
  {
    "alias": "rsly-fork-hill-kitchen"
  },
  {
    "alias": "juniper-bar-new-york"
  },
  {
    "alias": "rsly-babylon-restaurant-and-bar"
  },
  {
    "alias": "rsly-the-black-forest"
  },
  {
    "alias": "baccarat-boutique-bbar-and-lounge-miami"
  },
  {
    "alias": "the-center-club-baltimore"
  },
  {
    "alias": "marumi-new-york"
  },
  {
    "alias": "daltons-bar-and-grill-new-york"
  },
  {
    "alias": "lupitas-restaurant-new-york-2"
  },
  {
    "alias": "rsly-grill-don-andres"
  },
  {
    "alias": "oyster-oyster-washington"
  },
  {
    "alias": "il-mulino-new-york-uptown-new-york-3"
  },
  {
    "alias": "the-mean-fiddler-new-york"
  },
  {
    "alias": "the-dutch-new-york"
  },
  {
    "alias": "del-friscos-grille-new-york-4"
  },
  {
    "alias": "baia-beach-club-miami-miami-beach"
  },
  {
    "alias": "tartine-new-york"
  },
  {
    "alias": "boqueria-soho-new-york-2"
  },
  {
    "alias": "sylvias-restaurant-new-york"
  },
  {
    "alias": "casa-tua-cucina-miami"
  },
  {
    "alias": "hortus-nyc-new-york"
  },
  {
    "alias": "modern-garden-miami"
  },
  {
    "alias": "sushi-by-bou-times-square-new-york"
  },
  {
    "alias": "harris-restaurant-san-francisco"
  },
  {
    "alias": "rsly-rod-s-steak-seafood-grille"
  },
  {
    "alias": "seans-bar-and-kitchen-new-york"
  },
  {
    "alias": "rsly-la-ferme-restaurant"
  },
  {
    "alias": "rsly-desire-to-be-well-juicery---fresh-express-at-southpointe"
  },
  {
    "alias": "rsly-handsome-dan-s"
  },
  {
    "alias": "family-meal-at-blue-hill-new-york"
  },
  {
    "alias": "chamoun-s-way-new-york-6"
  },
  {
    "alias": "the-orchard-townhouse-new-york"
  },
  {
    "alias": "canaletto-restaurant-new-york"
  },
  {
    "alias": "la-chaumiere-washington-4"
  },
  {
    "alias": "sax-restaurant-and-lounge-washington-4"
  },
  {
    "alias": "armani-ristorante-new-york"
  },
  {
    "alias": "orilla-bar-and-grill-miami-beach"
  },
  {
    "alias": "rsly-the-maquis-cuisine"
  },
  {
    "alias": "teddy-and-the-bully-bar-washington"
  },
  {
    "alias": "l-adresse-new-york"
  },
  {
    "alias": "rsly-rear-end-gastropub-garage"
  },
  {
    "alias": "sasabune-new-york"
  },
  {
    "alias": "club-a-steakhouse-new-york"
  },
  {
    "alias": "maison-cheryl-arlington"
  },
  {
    "alias": "surya-madam-ji-new-york"
  },
  {
    "alias": "pylos-new-york"
  },
  {
    "alias": "anassa-taverna-nyc-new-york"
  },
  {
    "alias": "pergola-new-york-4"
  },
  {
    "alias": "la-mere-michelle-saratoga"
  },
  {
    "alias": "rsly-bottle-hill-tavern"
  },
  {
    "alias": "rsly-red-hound"
  },
  {
    "alias": "level-iii-san-francisco-3"
  },
  {
    "alias": "on-ocean-7-cafe-miami-beach"
  },
  {
    "alias": "hamachi-34-new-york-2"
  },
  {
    "alias": "rsly-chef-fredy-s-table"
  },
  {
    "alias": "biricchino-new-york-2"
  },
  {
    "alias": "rsly-fig-ash"
  },
  {
    "alias": "bar-goyana-new-york"
  },
  {
    "alias": "rsly-cafe-flore"
  },
  {
    "alias": "walrus-rodeo-miami"
  },
  {
    "alias": "the-warren-new-york"
  },
  {
    "alias": "adyar-ananda-bhavan-new-york"
  },
  {
    "alias": "rsly-valley-restaurant"
  },
  {
    "alias": "rsly-zora-restaurant-kafana-zora"
  },
  {
    "alias": "rsly-olde-mill-inn"
  },
  {
    "alias": "el-quijote-new-york-3"
  },
  {
    "alias": "rsly-rockin-ribs"
  },
  {
    "alias": "del-friscos-double-eagle-steakhouse-washington"
  },
  {
    "alias": "bix-san-francisco"
  },
  {
    "alias": "rsly-pitt-s"
  },
  {
    "alias": "gitano-miami-at-casa-faena-miami-beach-3"
  },
  {
    "alias": "rsly-white-owl-tavern"
  },
  {
    "alias": "ondo-jersey-city-jersey-city"
  },
  {
    "alias": "rsly-ihop"
  },
  {
    "alias": "rsly-mahsil"
  },
  {
    "alias": "rsly-urban-plates"
  },
  {
    "alias": "empellón-taqueria-new-york"
  },
  {
    "alias": "tocqueville-new-york-6"
  },
  {
    "alias": "zeppelin-washington"
  },
  {
    "alias": "nan-xiang-xiao-long-bao-manhattan-new-york"
  },
  {
    "alias": "rsly-hi-fi-tex-mex-bbq-mosaic"
  },
  {
    "alias": "rsly-chester-diner"
  },
  {
    "alias": "jaya-at-the-setai-miami-beach-2"
  },
  {
    "alias": "bison-and-bourbon-brooklyn"
  },
  {
    "alias": "entwine-new-york"
  },
  {
    "alias": "sams-place-new-york"
  },
  {
    "alias": "millburn-standard-millburn"
  },
  {
    "alias": "corkbuzz-restaurant-and-wine-bar-new-york"
  },
  {
    "alias": "okami-miami-design-district-miami-3"
  },
  {
    "alias": "smith-and-wollensky-miami-beach"
  },
  {
    "alias": "anomaly-sf-san-francisco-2"
  },
  {
    "alias": "kokkari-estiatorio-san-francisco"
  },
  {
    "alias": "rsly-el-rey-chicken"
  },
  {
    "alias": "osteria-del-teatro-miami-beach"
  },
  {
    "alias": "credo-san-francisco"
  },
  {
    "alias": "old-homestead-steak-house-new-york"
  },
  {
    "alias": "fairfax-new-york-2"
  },
  {
    "alias": "zion-kitchen-lounge-and-cafe-washington"
  },
  {
    "alias": "dauphine-s-washington"
  },
  {
    "alias": "rsly-gnocchi-on-9th"
  },
  {
    "alias": "karasu-brooklyn-2"
  },
  {
    "alias": "song-e-napule-new-york"
  },
  {
    "alias": "rsly-blend-lic"
  },
  {
    "alias": "harbor-nyc-new-york"
  },
  {
    "alias": "jajaja-mexicana-new-york-3"
  },
  {
    "alias": "kissaki-omakase-new-york-7"
  },
  {
    "alias": "rsly-rice-n-stew-co---food-on-the-go"
  },
  {
    "alias": "la-vara-brooklyn"
  },
  {
    "alias": "craft-new-york"
  },
  {
    "alias": "o-ku-washington-2"
  },
  {
    "alias": "d-j-reynolds-new-york-5"
  },
  {
    "alias": "third-avenue-ale-house-new-york"
  },
  {
    "alias": "kingbird-washington"
  },
  {
    "alias": "rsly-enzo-s-ristorante-pizzeria"
  },
  {
    "alias": "rsly-so-soulful-eatery"
  },
  {
    "alias": "kuruma-zushi-new-york"
  },
  {
    "alias": "off-the-wagon-new-york"
  },
  {
    "alias": "bethesda-crab-house-bethesda"
  },
  {
    "alias": "rabbit-house-omakase-and-sake-bar-new-york"
  },
  {
    "alias": "rsly-bonchon-annandale"
  },
  {
    "alias": "flea-street-menlo-park"
  },
  {
    "alias": "kebab-kurry-laguna-beach-3"
  },
  {
    "alias": "dleña-by-chef-richard-sandoval-washington"
  },
  {
    "alias": "bangia-new-york-2"
  },
  {
    "alias": "dinosaur-bar-b-que-new-york-4"
  },
  {
    "alias": "crab-house-at-pier-39-san-francisco-3"
  },
  {
    "alias": "chi-spacca-los-angeles"
  },
  {
    "alias": "zuma-new-york-2"
  },
  {
    "alias": "majorelle-new-york"
  },
  {
    "alias": "yuzu-new-york"
  },
  {
    "alias": "the-stinger-cocktail-bar-and-kitchen-new-york-3"
  },
  {
    "alias": "oscars-place-new-york-2"
  },
  {
    "alias": "la-pergola-millburn"
  },
  {
    "alias": "rsly-el-rincon-restaurant"
  },
  {
    "alias": "wineworks-for-everyone-mission-viejo"
  },
  {
    "alias": "closter-number-one-chinese-restaurant-closter-2"
  },
  {
    "alias": "taichi-pot-shabu-shabu-santa-clara-10"
  },
  {
    "alias": "rsly-weekly-meals-chicago"
  },
  {
    "alias": "rsly-el-captain-waffles-crepes"
  },
  {
    "alias": "da-gennaro-new-york"
  },
  {
    "alias": "quality-italian-new-york"
  },
  {
    "alias": "papillon-bistro-and-bar-new-york"
  },
  {
    "alias": "hangawi-new-york"
  },
  {
    "alias": "luca-osteria-coral-gables"
  },
  {
    "alias": "sette-mezzo-new-york"
  },
  {
    "alias": "rsly-elena-james-all-day"
  },
  {
    "alias": "basilico-millburn-2"
  },
  {
    "alias": "tartinery-new-york-13"
  },
  {
    "alias": "le-sia-new-york-4"
  },
  {
    "alias": "mkt-restaurant-and-bar-san-francisco"
  },
  {
    "alias": "rsly-shady-grove"
  },
  {
    "alias": "seapot-hot-pot-sunnyvale"
  },
  {
    "alias": "nikko-hibachi-asian-fusion-new-york-2"
  },
  {
    "alias": "mignonette-miami-7"
  },
  {
    "alias": "rsly-arden"
  },
  {
    "alias": "pig-and-khao-new-york"
  },
  {
    "alias": "rsly-the-staley"
  },
  {
    "alias": "rsly-charleys-cheesesteaks-wings"
  },
  {
    "alias": "rsly-chef-ngee-kitchen"
  },
  {
    "alias": "par-440-restaurant-and-lounge-short-hills"
  },
  {
    "alias": "rsly-cositas-ricas"
  },
  {
    "alias": "alison-new-york"
  },
  {
    "alias": "rafele-ristorante-new-york"
  },
  {
    "alias": "rsly-aruba-island-bowls-cafe"
  },
  {
    "alias": "rsly-anthony-sons-bakery-italian-deli"
  },
  {
    "alias": "trabuco-oaks-steak-house-trabuco-canyon"
  },
  {
    "alias": "jack-doyles-bar-and-restaurant-new-york"
  },
  {
    "alias": "rsly-sofia-s-fine-italian-cuisine-restaurant"
  },
  {
    "alias": "caliente-cab-new-york-2"
  },
  {
    "alias": "som-bo-new-york-2"
  },
  {
    "alias": "kawa-sushi-new-york"
  },
  {
    "alias": "artisan-restaurant-west-hartford"
  },
  {
    "alias": "restaurante-tio-pepe-baltimore-2"
  },
  {
    "alias": "the-lexington-social-new-york"
  },
  {
    "alias": "rsly-perrotti-s-far-hills"
  },
  {
    "alias": "rsly-mountain-hill-bistro"
  },
  {
    "alias": "rsly-first-watch"
  },
  {
    "alias": "the-melting-pot-towson-towson-2"
  },
  {
    "alias": "yakitori-totto-new-york"
  },
  {
    "alias": "rsly-zabaadi-kebabs"
  },
  {
    "alias": "otway-brooklyn"
  },
  {
    "alias": "rsly-tasty-savor"
  },
  {
    "alias": "paul-and-jimmys-new-york"
  },
  {
    "alias": "la-stanza-new-york"
  },
  {
    "alias": "rsly-hemlock-house"
  },
  {
    "alias": "cane-fire-grille-miami"
  },
  {
    "alias": "chow-house-new-york"
  },
  {
    "alias": "sails-bar-and-grill-norwalk"
  },
  {
    "alias": "panini-grill-new-york-2"
  },
  {
    "alias": "rsly-bar-marco"
  },
  {
    "alias": "rsly-maman"
  },
  {
    "alias": "sophra-grill-new-york"
  },
  {
    "alias": "rsly-tepache-mexican-kitchen-bar"
  },
  {
    "alias": "reichenbach-hall-new-york"
  },
  {
    "alias": "jasmines-caribbean-cuisine-new-york"
  },
  {
    "alias": "willow-vegan-restaurant-new-york"
  },
  {
    "alias": "le-desales-washington"
  },
  {
    "alias": "doya-miami"
  },
  {
    "alias": "fumo-harlem-new-york"
  },
  {
    "alias": "nusr-et-steakhouse-miami"
  },
  {
    "alias": "serafina-san-francisco"
  },
  {
    "alias": "sevilla-restaurant-new-york"
  },
  {
    "alias": "casa-mono-new-york"
  },
  {
    "alias": "chocolat-restaurant-and-bar-new-york-3"
  },
  {
    "alias": "rsly-i-m-eddie-cano"
  },
  {
    "alias": "rsly-morcilla"
  },
  {
    "alias": "matterhorn-restaurant-and-bakery-san-francisco-2"
  },
  {
    "alias": "rsly-dominick-s-pizza"
  },
  {
    "alias": "rsly-motorkat"
  },
  {
    "alias": "tsunami-panhandle-san-francisco-2"
  },
  {
    "alias": "sequoia-washington-11"
  },
  {
    "alias": "rsly-golden-age-beer-company"
  },
  {
    "alias": "mission-ceviche-new-york-3"
  },
  {
    "alias": "republic-latin-fusion-brooklyn"
  },
  {
    "alias": "rsly-the-marylander"
  },
  {
    "alias": "sotto-sopra-baltimore"
  },
  {
    "alias": "loring-place-new-york-2"
  },
  {
    "alias": "rsly-guantanamera"
  },
  {
    "alias": "iron-gate-washington"
  },
  {
    "alias": "fin-raw-bar-and-kitchen-summit"
  },
  {
    "alias": "hayes-street-grill-san-francisco"
  },
  {
    "alias": "land-of-plenty-new-york"
  },
  {
    "alias": "bricolage-brooklyn"
  },
  {
    "alias": "jack-rose-dining-saloon-washington"
  },
  {
    "alias": "russian-samovar-restaurant-and-piano-bar-new-york-2"
  },
  {
    "alias": "rsly-new-best-sub"
  },
  {
    "alias": "rsly-uncle-momo"
  },
  {
    "alias": "la-sirene-new-york-4"
  },
  {
    "alias": "pace-los-angeles-3"
  },
  {
    "alias": "rsly-one-by-spork"
  },
  {
    "alias": "piccolino-ristorante-mission-viejo"
  },
  {
    "alias": "rsly-mia-nonna-s-cucina"
  },
  {
    "alias": "rsly-jora"
  },
  {
    "alias": "hwa-yuan-new-york-2"
  },
  {
    "alias": "rsly-efsane-mediterranean-cuisine"
  },
  {
    "alias": "rsly-shah-s-halal-food"
  },
  {
    "alias": "evvia-estiatorio-palo-alto"
  },
  {
    "alias": "osteria-brooklyn-brooklyn"
  },
  {
    "alias": "alma-cocina-latina-baltimore"
  },
  {
    "alias": "la-taberna-steak-and-tapas-bar-dumont"
  },
  {
    "alias": "cut-new-york-city-new-york"
  },
  {
    "alias": "aquavit-new-york"
  },
  {
    "alias": "one-pot-shabu-shabu-cupertino-cupertino"
  },
  {
    "alias": "rsly-bull-river-taco-co-"
  },
  {
    "alias": "kitchen-kocktails-washington"
  },
  {
    "alias": "castell-rooftop-lounge-new-york"
  },
  {
    "alias": "cipriani-dolci-new-york"
  },
  {
    "alias": "99-favor-taste-new-york-new-york"
  },
  {
    "alias": "firehouse-bistro-woodside"
  },
  {
    "alias": "grand-central-oyster-bar-and-restaurant-new-york"
  },
  {
    "alias": "jeffreys-grocery-new-york"
  },
  {
    "alias": "uluh-new-york"
  },
  {
    "alias": "rsly-bangalore-tiffin-room-btr-"
  },
  {
    "alias": "sushi-on-jones-new-york"
  },
  {
    "alias": "le-zie-new-york"
  },
  {
    "alias": "turkuaz-restaurant-new-york-16"
  },
  {
    "alias": "rsly-4747lic"
  },
  {
    "alias": "central-michel-richard-washington"
  },
  {
    "alias": "blvd-bistro-new-york"
  },
  {
    "alias": "cornerstone-tavern-new-york-2"
  },
  {
    "alias": "rsly-bloom-chicken"
  },
  {
    "alias": "l-artusi-new-york"
  },
  {
    "alias": "the-noortwyck-new-york"
  },
  {
    "alias": "little-collins-new-york-3"
  },
  {
    "alias": "ramerino-italian-prime-new-york"
  },
  {
    "alias": "the-whitby-bar-and-restaurant-new-york"
  },
  {
    "alias": "sergimmo-salumeria-new-york"
  },
  {
    "alias": "baiocco-miami-2"
  },
  {
    "alias": "rsly-raising-cane-s-chicken-fingers"
  },
  {
    "alias": "rib-no-7-new-york"
  },
  {
    "alias": "rsly-roasted-breadfruit-smokehouse-and-grill"
  },
  {
    "alias": "turks-inn-brooklyn"
  },
  {
    "alias": "horus-too-new-york"
  },
  {
    "alias": "duke-eatery-new-york-2"
  },
  {
    "alias": "seasons-restaurant-washington"
  },
  {
    "alias": "il-posto-accanto-new-york"
  },
  {
    "alias": "miss-ada-brooklyn-2"
  },
  {
    "alias": "sardis-new-york"
  },
  {
    "alias": "cavatina-west-hollywood-2"
  },
  {
    "alias": "altro-paradiso-new-york"
  },
  {
    "alias": "little-owl-new-york-3"
  },
  {
    "alias": "amali-new-york-3"
  },
  {
    "alias": "fogo-de-chao-brazilian-steakhouse-washington-10"
  },
  {
    "alias": "the-mermaid-inn-chelsea-new-york"
  },
  {
    "alias": "ox-and-tiger-san-francisco"
  },
  {
    "alias": "connie-and-teds-west-hollywood-2"
  },
  {
    "alias": "elephant-and-castle-new-york"
  },
  {
    "alias": "copinette-new-york-3"
  },
  {
    "alias": "goldie-s-tavern-new-york"
  },
  {
    "alias": "eveleigh-west-hollywood"
  },
  {
    "alias": "boulud-sud-miami-miami-2"
  },
  {
    "alias": "rsly-beyer-deli"
  },
  {
    "alias": "tea-and-sympathy-new-york"
  },
  {
    "alias": "raku-its-japanese-new-york-2"
  },
  {
    "alias": "matsu-sushi-new-york-4"
  },
  {
    "alias": "rsly-peaches"
  },
  {
    "alias": "pasquale-jones-new-york"
  },
  {
    "alias": "pasta-lovers-trattoria-new-york-2"
  },
  {
    "alias": "artisan-southport"
  },
  {
    "alias": "rsly-the-sweet-sap"
  },
  {
    "alias": "elmo-new-york"
  },
  {
    "alias": "makimaki-sushi-new-york-5"
  },
  {
    "alias": "yakiniq-san-francisco-4"
  },
  {
    "alias": "rsly-compton-s"
  },
  {
    "alias": "silver-star-new-york"
  },
  {
    "alias": "top-thai-greenwich-new-york"
  },
  {
    "alias": "rsly-shemalis"
  },
  {
    "alias": "los-mariscos-new-york"
  },
  {
    "alias": "the-lexington-house-los-gatos"
  },
  {
    "alias": "barbaresco-restaurant-new-york"
  },
  {
    "alias": "the-junction-new-york"
  },
  {
    "alias": "takahachi-tribeca-restaurant-new-york"
  },
  {
    "alias": "harbs-soho-new-york-3"
  },
  {
    "alias": "rsly-swan-grill"
  },
  {
    "alias": "jongro-bbq-wheaton"
  },
  {
    "alias": "rsly-mendham-bagel-and-coffee-shop"
  },
  {
    "alias": "jang-su-jang-santa-clara"
  },
  {
    "alias": "clove-indian-restaurant-and-bar-new-york"
  },
  {
    "alias": "shinn-east-new-york"
  },
  {
    "alias": "jojo-new-york-3"
  },
  {
    "alias": "rsly-florentin"
  },
  {
    "alias": "marlowe-san-francisco-2"
  },
  {
    "alias": "kuma-sushi-sake-san-francisco"
  },
  {
    "alias": "tim-ho-wan-hells-kitchen-new-york-2"
  },
  {
    "alias": "shukette-new-york"
  },
  {
    "alias": "rsly-driftwood-oven"
  },
  {
    "alias": "rsly-the-windlass"
  },
  {
    "alias": "ten-twenty-post-oyster-bar-and-bistro-darien"
  },
  {
    "alias": "carmines-italian-restaurant-times-square-new-york-5"
  },
  {
    "alias": "rsly-teppanyaki-one-japanese-grill-teriyaki-sushi-"
  },
  {
    "alias": "kung-fu-kitchen-new-york-2"
  },
  {
    "alias": "judge-roy-bean-public-house-new-york"
  },
  {
    "alias": "nare-sushi-new-york"
  },
  {
    "alias": "locanda-vini-e-olii-brooklyn-4"
  },
  {
    "alias": "patiala-indian-grill-new-york"
  },
  {
    "alias": "rsly-south-pine-american-eatery"
  },
  {
    "alias": "udon-lab-new-york"
  },
  {
    "alias": "scalini-fedeli-new-york"
  },
  {
    "alias": "rsly-marco-polo"
  },
  {
    "alias": "la-cuchara-baltimore"
  },
  {
    "alias": "rsly-nan-xiang-soup-dumplings---pittsburgh"
  },
  {
    "alias": "rsly-lilith"
  },
  {
    "alias": "rsly-agave-maiz"
  },
  {
    "alias": "abacá-san-francisco-3"
  },
  {
    "alias": "rsly-milk-bar"
  },
  {
    "alias": "antique-garage-tribeca-new-york"
  },
  {
    "alias": "rsly-applebee-s-grill-bar"
  },
  {
    "alias": "rsly-sharpies-pizza-cocktails"
  },
  {
    "alias": "rsly-fogonero-austin"
  },
  {
    "alias": "death-ave-new-york-5"
  },
  {
    "alias": "olmsted-brooklyn"
  },
  {
    "alias": "da-flora-a-venetian-osteria-san-francisco"
  },
  {
    "alias": "rsly-dominick-s"
  },
  {
    "alias": "el-puerto-seafood-new-york"
  },
  {
    "alias": "abcv-new-york-2"
  },
  {
    "alias": "the-bar-room-at-the-modern-new-york-3"
  },
  {
    "alias": "rsly-ridge-italian-comfort-food"
  },
  {
    "alias": "gopchang-story-bbq-new-york"
  },
  {
    "alias": "halifax-hoboken-2"
  },
  {
    "alias": "gibson-san-francisco"
  },
  {
    "alias": "rsly-little-diner"
  },
  {
    "alias": "sushi-star-new-york"
  },
  {
    "alias": "rsly-italianissimo-trattoria"
  },
  {
    "alias": "kati-shop-new-york-7"
  },
  {
    "alias": "rsly-kassa-kai-mumbai"
  },
  {
    "alias": "bar-masa-new-york"
  },
  {
    "alias": "the-regency-bar-and-grill-new-york-2"
  },
  {
    "alias": "malaparte-new-york"
  },
  {
    "alias": "rsly-butler-s-pantry-trackside"
  },
  {
    "alias": "rsly-benjyehuda---wacker"
  },
  {
    "alias": "macao-trading-company-new-york"
  },
  {
    "alias": "paint-n-pour-new-york-4"
  },
  {
    "alias": "rsly-91-restaurant-bar"
  },
  {
    "alias": "pelican-cafe-miami-beach-3"
  },
  {
    "alias": "ginnys-supper-club-new-york"
  },
  {
    "alias": "pied-piper-san-francisco-san-francisco"
  },
  {
    "alias": "the-river-oyster-bar-miami-4"
  },
  {
    "alias": "musso-and-frank-grill-hollywood"
  },
  {
    "alias": "mulligans-pub-new-york"
  },
  {
    "alias": "polash-new-york"
  },
  {
    "alias": "sakagura-new-york"
  },
  {
    "alias": "donburiya-new-york-2"
  },
  {
    "alias": "rsly-e-town-bar-grill"
  },
  {
    "alias": "rsly-chart-house"
  },
  {
    "alias": "vida-miami-beach-2"
  },
  {
    "alias": "rsly-capisce-trattoria"
  },
  {
    "alias": "rsly-gan-hoo-bbq"
  },
  {
    "alias": "cuba-restaurant-and-rum-bar-new-york"
  },
  {
    "alias": "lido-new-york"
  },
  {
    "alias": "hummus-kitchen-new-york"
  },
  {
    "alias": "madeo-ristorante-west-hollywood"
  },
  {
    "alias": "rsly-kiori-kitchen"
  },
  {
    "alias": "istanbul-kebab-house-new-york"
  },
  {
    "alias": "rsly-cafe-azzurro"
  },
  {
    "alias": "vu-jersey-city"
  },
  {
    "alias": "club-room-at-soho-grand-new-york-2"
  },
  {
    "alias": "elis-essentials-new-york-9"
  },
  {
    "alias": "tara-rose-new-york"
  },
  {
    "alias": "nick-stef-s-steakhouse-new-york"
  },
  {
    "alias": "the-ocean-grill-miami-beach"
  },
  {
    "alias": "stingray-lounge-uptown-hoboken-2"
  },
  {
    "alias": "brazen-head-san-francisco"
  },
  {
    "alias": "rsly-crown-one-"
  },
  {
    "alias": "elephant-sushi-san-francisco"
  },
  {
    "alias": "laurel-hardware-west-hollywood-2"
  },
  {
    "alias": "riot-house-restaurant-and-bar-west-hollywood"
  },
  {
    "alias": "joju-new-york-2"
  },
  {
    "alias": "bar-italia-madison-new-york"
  },
  {
    "alias": "club-19-restaurant-southington"
  },
  {
    "alias": "the-flatiron-room-nomad-new-york-3"
  },
  {
    "alias": "rsly-el-sitio"
  },
  {
    "alias": "el-lopo-san-francisco-2"
  },
  {
    "alias": "shoo-shoo-new-york"
  },
  {
    "alias": "rsly-romanissimo-cucina-italiana"
  },
  {
    "alias": "fiola-mare-washington"
  },
  {
    "alias": "bonnies-brooklyn"
  },
  {
    "alias": "komodo-miami-2"
  },
  {
    "alias": "chirp-new-york-3"
  },
  {
    "alias": "rsly-ninety-acres"
  },
  {
    "alias": "cafe-carlyle-new-york-4"
  },
  {
    "alias": "amber-west-village-new-york-93"
  },
  {
    "alias": "83-1-2-new-york"
  },
  {
    "alias": "novikov-miami-miami"
  },
  {
    "alias": "mikes-bistro-new-york-2"
  },
  {
    "alias": "lex-restaurant-new-york"
  },
  {
    "alias": "bobo-new-york"
  },
  {
    "alias": "the-terrace-and-outdoor-gardens-new-york-2"
  },
  {
    "alias": "bin-14-hoboken"
  },
  {
    "alias": "gayles-broadway-rose-new-york"
  },
  {
    "alias": "cote-miami-miami-2"
  },
  {
    "alias": "rsly-sabe-a-zulia-winston-plaza"
  },
  {
    "alias": "steamers-grillhouse-los-gatos"
  },
  {
    "alias": "cotenna-new-york"
  },
  {
    "alias": "rsly-tabor-road-tavern"
  },
  {
    "alias": "rsly-juliza-s-colombian-latin-fusion"
  },
  {
    "alias": "cosme-new-york"
  },
  {
    "alias": "cathédrale-restaurant-new-york-city"
  },
  {
    "alias": "rsly-lung-yung-restaurant"
  },
  {
    "alias": "africa-kine-restaurant-new-york-2"
  },
  {
    "alias": "rsly-pasta-lab-nyc"
  },
  {
    "alias": "gallaghers-steakhouse-new-york"
  },
  {
    "alias": "fleming-s-prime-steakhouse-and-wine-bar-miami-2"
  },
  {
    "alias": "mercato-new-york"
  },
  {
    "alias": "milk-and-roses-brooklyn"
  },
  {
    "alias": "il-cortile-restaurant-new-york"
  },
  {
    "alias": "rsly-on-st-elmo"
  },
  {
    "alias": "rsly-cafe-vincotto"
  },
  {
    "alias": "cinghiale-baltimore-3"
  },
  {
    "alias": "rsly-sergimmo-salumeria-whitestone"
  },
  {
    "alias": "pio-pio-8-new-york-5"
  },
  {
    "alias": "tonys-di-napoli-new-york-7"
  },
  {
    "alias": "the-smith-new-york-7"
  },
  {
    "alias": "rsly-bruno-s-italian-bistro"
  },
  {
    "alias": "sun-rise-house-north-haven"
  },
  {
    "alias": "rsly-bowery-bungalow-nyc"
  },
  {
    "alias": "chai-thai-kitchen-new-york-10"
  },
  {
    "alias": "employees-only-west-hollywood"
  },
  {
    "alias": "fior-d-italia-san-francisco-4"
  },
  {
    "alias": "caviar-russe-miami"
  },
  {
    "alias": "isa-restaurant-san-francisco"
  },
  {
    "alias": "parallel-37-san-francisco"
  },
  {
    "alias": "rsly-cap-t-loui"
  },
  {
    "alias": "giannis-miami-beach-5"
  },
  {
    "alias": "rsly-beneci-s-d-italia-cucina"
  },
  {
    "alias": "dino-and-harry-s-steakhouse-hoboken"
  },
  {
    "alias": "rsly-yakup-bey-chicago"
  },
  {
    "alias": "rsly-blue-tijuana-barzola"
  },
  {
    "alias": "pommes-frites-new-york-2"
  },
  {
    "alias": "kosaka-new-york-2"
  },
  {
    "alias": "babbo-new-york"
  },
  {
    "alias": "faiccos-italian-specialties-new-york"
  },
  {
    "alias": "match-restaurant-norwalk"
  },
  {
    "alias": "le-gigot-new-york"
  },
  {
    "alias": "rsly-cityview-rooftop-lounge"
  },
  {
    "alias": "rsly-penny-s-diner"
  },
  {
    "alias": "kyu-new-york-new-york-2"
  },
  {
    "alias": "rsly-hupo-best-szechuan-food-in-lic"
  },
  {
    "alias": "rsly-il-giglio-tribeca"
  },
  {
    "alias": "boqueria-dupont-washington"
  },
  {
    "alias": "lillies-victorian-establishment-new-york-2"
  },
  {
    "alias": "rh-guesthouse-the-dining-room-new-york"
  },
  {
    "alias": "papi-steak-miami-beach"
  },
  {
    "alias": "tao-asian-bistro-los-angeles-2"
  },
  {
    "alias": "fiola-washington"
  },
  {
    "alias": "peak-thai-restaurant-new-york"
  },
  {
    "alias": "catch-steak-new-york"
  },
  {
    "alias": "sotto-13-new-york-7"
  },
  {
    "alias": "casa-publica-brooklyn-2"
  },
  {
    "alias": "osteria-la-buca-los-angeles-2"
  },
  {
    "alias": "loulou-petit-bistro-and-speakeasy-new-york"
  },
  {
    "alias": "cervos-new-york"
  },
  {
    "alias": "rsly-kimball-coastal-eatery"
  },
  {
    "alias": "rsly-cinders-wood-fire-grill"
  },
  {
    "alias": "adams-rib-restaurant-norwalk-2"
  },
  {
    "alias": "omakase-room-by-mitsu-new-york"
  },
  {
    "alias": "blue-seafood-bar-new-york"
  },
  {
    "alias": "thai-peppercorn-new-york-2"
  },
  {
    "alias": "empellón-new-york-3"
  },
  {
    "alias": "parnells-pub-and-restaurant-new-york"
  },
  {
    "alias": "sen-sakana-new-york"
  },
  {
    "alias": "mastros-steakhouse-new-york"
  },
  {
    "alias": "ajisai-japanese-fusion-new-york"
  },
  {
    "alias": "oso-new-york"
  },
  {
    "alias": "rsly-mang-eton-filipino-food"
  },
  {
    "alias": "bodega-malbec-toluca-lake"
  },
  {
    "alias": "il-tinello-ristorante-italiano-new-york"
  },
  {
    "alias": "sip-and-co-new-york"
  },
  {
    "alias": "rsly-cheros-grill"
  },
  {
    "alias": "quill-washington"
  },
  {
    "alias": "yoon-haeundae-galbi-new-york-2"
  },
  {
    "alias": "rsly-sunday-in-brooklyn"
  },
  {
    "alias": "rsly-chilangos-taqueria"
  },
  {
    "alias": "anejo-new-york-10"
  },
  {
    "alias": "rsly-stoney-brook-grille"
  },
  {
    "alias": "kintsugi-omakase-new-york-4"
  },
  {
    "alias": "rsly-millvale-market"
  },
  {
    "alias": "barbounia-new-york"
  },
  {
    "alias": "rsly-bab-alsalam-restaurant"
  },
  {
    "alias": "rsly-serpentine-cider-smokehouse"
  },
  {
    "alias": "rsly-etc-"
  },
  {
    "alias": "rsly-hibiscus-island-grille---randolph"
  },
  {
    "alias": "forte-dei-marmi-miami-beach"
  },
  {
    "alias": "la-cava-new-york"
  },
  {
    "alias": "arte-restaurant-new-york-2"
  },
  {
    "alias": "biagio-osteria-stratford"
  },
  {
    "alias": "fino-ristorante-san-francisco"
  },
  {
    "alias": "jungsik-new-york"
  },
  {
    "alias": "genes-restaurant-new-york"
  },
  {
    "alias": "scarlet-kitchen-and-lounge-rancho-mission-viejo-2"
  },
  {
    "alias": "melbas-restaurant-new-york-2"
  },
  {
    "alias": "azuki-japanese-restaurant-new-york"
  },
  {
    "alias": "loretta-and-the-butcher-miami"
  },
  {
    "alias": "tamarine-restaurant-palo-alto"
  },
  {
    "alias": "atla-new-york"
  },
  {
    "alias": "las-panteras-negras-new-york"
  },
  {
    "alias": "rsly-new-bamboo-garden"
  },
  {
    "alias": "upstairs-at-the-kimberly-new-york"
  },
  {
    "alias": "bin-100-restaurant-milford"
  },
  {
    "alias": "da-umberto-new-york-2"
  },
  {
    "alias": "l-orcio-new-haven-2"
  },
  {
    "alias": "torishin-new-york-3"
  },
  {
    "alias": "sorella-san-francisco"
  },
  {
    "alias": "giando-brooklyn"
  },
  {
    "alias": "peking-duck-house-new-york-2"
  },
  {
    "alias": "rsly-nana-teriyaki"
  },
  {
    "alias": "cellini-restaurant-new-york"
  },
  {
    "alias": "rolfs-new-york"
  },
  {
    "alias": "rsly-hills-of-herat"
  },
  {
    "alias": "le-district-market-district-new-york"
  },
  {
    "alias": "rsly-taste-of-egypt-cafe"
  },
  {
    "alias": "supra-washington-2"
  },
  {
    "alias": "strip-house-speakeasy-new-york"
  },
  {
    "alias": "rsly-tap-bitters"
  },
  {
    "alias": "francie-brooklyn"
  },
  {
    "alias": "koi-restaurant-new-york-2"
  },
  {
    "alias": "otaru-sushi-bar-new-haven"
  },
  {
    "alias": "bobby-vans-steakhouse-new-york-10"
  },
  {
    "alias": "annie-moores-bar-and-restaurant-new-york-2"
  },
  {
    "alias": "rsly-tortilleria-rosticeria-el-guerrerence"
  },
  {
    "alias": "the-waverly-inn-and-garden-new-york-2"
  },
  {
    "alias": "locanda-verde-new-york"
  },
  {
    "alias": "bobby-vans-grill-washington-2"
  },
  {
    "alias": "my-moon-brooklyn-2"
  },
  {
    "alias": "rsly-big-fish-dmv"
  },
  {
    "alias": "garibaldis-san-francisco-2"
  },
  {
    "alias": "the-palm-court-new-york"
  },
  {
    "alias": "legal-sea-foods-short-hills-short-hills-2"
  },
  {
    "alias": "marion-miami"
  },
  {
    "alias": "dante-west-village-new-york"
  },
  {
    "alias": "lure-fishbar-new-york-2"
  },
  {
    "alias": "rsly-la-sir-ne-soho"
  },
  {
    "alias": "momoya-new-york"
  },
  {
    "alias": "sushi-katsuei-new-york"
  },
  {
    "alias": "uncle-jacks-steakhouse-westside-new-york-3"
  },
  {
    "alias": "rsly-vegan-world-cafe"
  },
  {
    "alias": "rsly-855-knickerbocker-gourmet-deli"
  },
  {
    "alias": "marino-restaurant-los-angeles"
  },
  {
    "alias": "ci-siamo-new-york-5"
  },
  {
    "alias": "the-ashford-jersey-city-2"
  },
  {
    "alias": "valerie-new-york"
  },
  {
    "alias": "sake-bar-hagi-new-york-7"
  },
  {
    "alias": "roka-akor-san-francisco-san-francisco-4"
  },
  {
    "alias": "rsly-ph-steakhouse"
  },
  {
    "alias": "capt-loui-new-york"
  },
  {
    "alias": "daeho-kalbijjim-and-beef-soup-san-francisco-9"
  },
  {
    "alias": "café-d-avignon-the-moxy-times-square-new-york-5"
  },
  {
    "alias": "roeys-new-york"
  },
  {
    "alias": "johns-of-bleecker-street-new-york-2"
  },
  {
    "alias": "hasaki-new-york"
  },
  {
    "alias": "rasika-west-end-washington"
  },
  {
    "alias": "portale-new-york-2"
  },
  {
    "alias": "rsly-taqueria-coatzingo"
  },
  {
    "alias": "aura-cocina-brooklyn-2"
  },
  {
    "alias": "merchants-ny-new-york-8"
  },
  {
    "alias": "red-rooster-harlem-new-york-3"
  },
  {
    "alias": "cranes-spanish-kaiseki-washington"
  },
  {
    "alias": "il-mulino-prime-soho-new-york"
  },
  {
    "alias": "sant-ambroeus-west-village-new-york"
  },
  {
    "alias": "the-ainsworth-hoboken-hoboken"
  },
  {
    "alias": "the-palm-midtown-new-york"
  },
  {
    "alias": "rsly-nova-cafe-millvale"
  },
  {
    "alias": "rsly-blazin-craft-burgers-and-wings"
  },
  {
    "alias": "rsly-kalaveras"
  },
  {
    "alias": "flex-mussels-new-york-2"
  },
  {
    "alias": "mezzaluna-new-york"
  },
  {
    "alias": "st-anselm-washington"
  },
  {
    "alias": "district-tap-house-new-york"
  },
  {
    "alias": "rsly-cucina-biagio"
  },
  {
    "alias": "rsly-the-pizza-pub"
  },
  {
    "alias": "rsly-moe-s-bistro-and-bar"
  },
  {
    "alias": "san-carlo-osteria-piemonte-new-york-2"
  },
  {
    "alias": "tribeca-grill-new-york-2"
  },
  {
    "alias": "rsly-the-brinery"
  },
  {
    "alias": "marlow-and-sons-brooklyn-2"
  },
  {
    "alias": "yuca-105-miami-beach"
  },
  {
    "alias": "omusubi-gonbei-new-york-3"
  },
  {
    "alias": "ole-and-steen-new-york-4"
  },
  {
    "alias": "rsly-chicken-guy-"
  },
  {
    "alias": "ayza-wine-and-chocolate-bar-new-york-6"
  },
  {
    "alias": "san-marino-ristorante-new-york-2"
  },
  {
    "alias": "michaels-genuine-food-and-drink-miami"
  },
  {
    "alias": "el-encanto-de-lola-2-new-york"
  },
  {
    "alias": "rsly-the-address-greek-mediterranean-restaurant-"
  },
  {
    "alias": "ari-sushi-new-york"
  },
  {
    "alias": "rsly-bubbles-and-bites---dragon-tea"
  },
  {
    "alias": "kyma-new-york"
  },
  {
    "alias": "sushi-taro-washington"
  },
  {
    "alias": "madera-cuban-grill-and-steakhouse-long-island-city"
  },
  {
    "alias": "fig-and-olive-washington-9"
  },
  {
    "alias": "takumi-omakase-new-york"
  },
  {
    "alias": "brandy-library-new-york"
  },
  {
    "alias": "rsly-pusadee-s-garden"
  },
  {
    "alias": "the-alvin-public-house-new-york"
  },
  {
    "alias": "la-contenta-oeste-new-york"
  },
  {
    "alias": "rsly-sazon-cubano"
  },
  {
    "alias": "german-doner-kebab-midtown-new-york"
  },
  {
    "alias": "rsly-nekter-juice-bar"
  },
  {
    "alias": "frankie-and-johnnies-steak-house-new-york-3"
  },
  {
    "alias": "53-nyc-new-york"
  },
  {
    "alias": "pubbelly-sushi-miami-beach-miami-beach-3"
  },
  {
    "alias": "rsly-la-pecora-bianca-bryant-park"
  },
  {
    "alias": "tavern-on-the-green-new-york-7"
  },
  {
    "alias": "rsly-restaurant-el-achiote"
  },
  {
    "alias": "rsly-barzola"
  },
  {
    "alias": "fine-and-rare-new-york"
  },
  {
    "alias": "wayfare-tavern-san-francisco-2"
  },
  {
    "alias": "rsly-antojitos-la-herradura"
  },
  {
    "alias": "wild-new-york"
  },
  {
    "alias": "rsly-carmel-haifa"
  },
  {
    "alias": "don-giovanni-ristorante-new-york"
  },
  {
    "alias": "altovino-san-francisco"
  },
  {
    "alias": "jack-demseys-new-york"
  },
  {
    "alias": "et-voila-washington"
  },
  {
    "alias": "momoya-new-york-2"
  },
  {
    "alias": "rsly-mr-kimchi-korean-ayce-bbq-niles"
  },
  {
    "alias": "st-tropez-west-village-new-york-3"
  },
  {
    "alias": "rsly-lu-nello"
  },
  {
    "alias": "marwin-thai-restaurant-new-york"
  },
  {
    "alias": "sfoglina-rosslyn-arlington-2"
  },
  {
    "alias": "rsly-por-favor-el-cajon"
  },
  {
    "alias": "rusty-pelican-key-biscayne-3"
  },
  {
    "alias": "battello-jersey-city-3"
  },
  {
    "alias": "reserve-cut-new-york"
  },
  {
    "alias": "rsly-the-mediterranean-table"
  },
  {
    "alias": "rsly-pok-bowl-station---cobble-hill"
  },
  {
    "alias": "rsly-dish-osteria-bar"
  },
  {
    "alias": "rsly-drift"
  },
  {
    "alias": "rsly-ch-o-xo-ph-coffee-tea"
  },
  {
    "alias": "golden-wuish-new-york"
  },
  {
    "alias": "bistro-cacao-washington-2"
  },
  {
    "alias": "aretskys-patroon-new-york-2"
  },
  {
    "alias": "rsly-cacio-san-diego"
  },
  {
    "alias": "fausto-brooklyn"
  },
  {
    "alias": "havana-central-new-york-6"
  },
  {
    "alias": "zushi-puzzle-san-francisco-2"
  },
  {
    "alias": "members-los-angeles"
  },
  {
    "alias": "rsly-tas-eatery"
  },
  {
    "alias": "di-mauros-italian-restaurant-and-bar-miami-beach"
  },
  {
    "alias": "rsly-nandri-indian-cafe"
  },
  {
    "alias": "the-flatiron-room-murray-hill-new-york"
  },
  {
    "alias": "rsly-querico"
  },
  {
    "alias": "cacio-e-pepe-new-york-4"
  },
  {
    "alias": "sonoma-restaurant-and-wine-bar-washington"
  },
  {
    "alias": "rsly-taqueria-el-mariachi"
  },
  {
    "alias": "dolly-varden-new-york-2"
  },
  {
    "alias": "izakaya-toribar-new-york"
  },
  {
    "alias": "centrolina-washington"
  },
  {
    "alias": "rsly-city-works-market-square---pittsburgh-"
  },
  {
    "alias": "rsly-marco-s-pizza"
  },
  {
    "alias": "philippe-downtown-new-york"
  },
  {
    "alias": "rsly-eat-with-us"
  },
  {
    "alias": "rsly-meli-estiatorio"
  },
  {
    "alias": "rsly-pho-g-beef"
  },
  {
    "alias": "texas-rotisserie-and-grill-new-york"
  },
  {
    "alias": "rsly-kesari-indian-cuisine"
  },
  {
    "alias": "laser-wolf-brooklyn-2"
  },
  {
    "alias": "la-focaccia-summit"
  },
  {
    "alias": "hearth-new-york"
  },
  {
    "alias": "rsly-pastasole-chelsea"
  },
  {
    "alias": "tia-pol-new-york"
  },
  {
    "alias": "the-parlour-new-york-2"
  },
  {
    "alias": "calle-dao-chelsea-new-york-3"
  },
  {
    "alias": "mc-kitchen-miami"
  },
  {
    "alias": "gage-and-tollner-brooklyn"
  },
  {
    "alias": "rsly-big-shot-bob-s-house-of-wings---north-hills"
  },
  {
    "alias": "omakai-sushi-miami-4"
  },
  {
    "alias": "rsly-umami-asian-bistro-and-sushi-bar"
  },
  {
    "alias": "poseidon-greek-restaurant-and-outdoor-lounge-miami-beach-2"
  },
  {
    "alias": "rsly-cafe-la-maze"
  },
  {
    "alias": "ambo-new-york-2"
  },
  {
    "alias": "rsly-tongdee-thai"
  },
  {
    "alias": "the-north-fork-new-york-2"
  },
  {
    "alias": "rsly-burghers-brewing-co-millvale"
  },
  {
    "alias": "amara-at-paraiso-miami-2"
  },
  {
    "alias": "2-hopewell-south-glastonbury"
  },
  {
    "alias": "the-red-hen-washington-4"
  },
  {
    "alias": "chez-philippe-los-gatos-2"
  },
  {
    "alias": "indian-accent-new-york"
  },
  {
    "alias": "del-friscos-grille-hoboken"
  },
  {
    "alias": "mos-fishermans-wharf-inner-harbor-baltimore"
  },
  {
    "alias": "amor-cubano-new-york"
  },
  {
    "alias": "rsly-mountain-view-chalet"
  },
  {
    "alias": "ocean-prime-new-york"
  },
  {
    "alias": "campton-place-san-francisco"
  },
  {
    "alias": "taverna-palo-alto"
  },
  {
    "alias": "okinii-new-york"
  },
  {
    "alias": "coopers-craft-and-cocktails-new-york-2"
  },
  {
    "alias": "tagliata-baltimore"
  },
  {
    "alias": "imperfecto-washington"
  },
  {
    "alias": "the-perfect-pint-new-york"
  },
  {
    "alias": "rsly-trattoria-trecolori"
  },
  {
    "alias": "creole-on-14th-washington"
  },
  {
    "alias": "harbor-lights-norwalk"
  },
  {
    "alias": "rsly-parkside-tavern"
  },
  {
    "alias": "il-corallo-trattoria-new-york"
  },
  {
    "alias": "poulette-midtown-east-new-york"
  },
  {
    "alias": "rania-washington"
  },
  {
    "alias": "avra-48th-street-new-york"
  },
  {
    "alias": "augustinos-kitchen-and-bar-hoboken-2"
  },
  {
    "alias": "rsly-hubani-restaurant-"
  },
  {
    "alias": "bonda-restaurant-fairfield"
  },
  {
    "alias": "rsly-seventh-state-restaurant-and-lounge"
  },
  {
    "alias": "blue-duck-tavern-washington"
  },
  {
    "alias": "symposium-new-york-2"
  },
  {
    "alias": "casa-juancho-miami"
  },
  {
    "alias": "le-central-san-francisco-2"
  },
  {
    "alias": "the-grill-new-york-4"
  },
  {
    "alias": "la-lanterna-di-vittorio-new-york"
  },
  {
    "alias": "the-half-pint-new-york"
  },
  {
    "alias": "nonono-new-york-6"
  },
  {
    "alias": "stk-steakhouse-rooftop-nyc-new-york"
  },
  {
    "alias": "tabernacle-steakhouse-new-york"
  },
  {
    "alias": "rsly-fushimi-times-square"
  },
  {
    "alias": "sarabeths-central-park-new-york"
  },
  {
    "alias": "cara-restaurant-los-angeles"
  },
  {
    "alias": "wallse-new-york-8"
  },
  {
    "alias": "rsly-san-soo-kap-san-best-korean-bbq-flushing"
  },
  {
    "alias": "sushi-of-gari-46-new-york"
  },
  {
    "alias": "fogo-de-chao-irvine-2"
  },
  {
    "alias": "rsly-maison-close-restaurant"
  },
  {
    "alias": "sushi-on-jones-new-york-3"
  },
  {
    "alias": "graces-new-york"
  },
  {
    "alias": "bacaro-new-york"
  },
  {
    "alias": "polenteria-los-gatos"
  },
  {
    "alias": "che-fico-alimentari-san-francisco"
  },
  {
    "alias": "oxomoco-brooklyn-2"
  },
  {
    "alias": "dragon-town-new-york-2"
  },
  {
    "alias": "rsly-bistro-46"
  },
  {
    "alias": "the-carriage-house-restaurant-millburn"
  },
  {
    "alias": "rsly-jackson-s-eatery-bar"
  },
  {
    "alias": "bar-moga-new-york-2"
  },
  {
    "alias": "rsly-joy-by-seven-reasons"
  },
  {
    "alias": "rsly-rowdy-bbq"
  },
  {
    "alias": "rue-57-new-york-3"
  },
  {
    "alias": "max-soha-restaurant-new-york"
  },
  {
    "alias": "mortons-the-steakhouse-san-francisco"
  },
  {
    "alias": "mccormick-and-schmicks-seafood-and-steaks-baltimore-2"
  },
  {
    "alias": "dhamaka-new-york"
  },
  {
    "alias": "la-bohème-west-hollywood-3"
  },
  {
    "alias": "yefsi-estiatorio-new-york"
  },
  {
    "alias": "balzem-new-york"
  },
  {
    "alias": "sathi-new-york"
  },
  {
    "alias": "spqr-san-francisco"
  },
  {
    "alias": "nataz-restaurant-southington"
  },
  {
    "alias": "one-dine-new-york"
  },
  {
    "alias": "bombay-bistro-new-york-2"
  },
  {
    "alias": "vina-enoteca-palo-alto-4"
  },
  {
    "alias": "xiquet-by-danny-lledó-washington"
  },
  {
    "alias": "rsly-mr-shawarma-el-cajon"
  },
  {
    "alias": "toku-unagi-and-sushi-west-hollywood-2"
  },
  {
    "alias": "minetta-tavern-new-york"
  },
  {
    "alias": "bistrot-lepic-and-wine-bar-washington"
  },
  {
    "alias": "rsly-washington-house-restaurant"
  },
  {
    "alias": "jerrell-s-betr-brgr-new-york"
  },
  {
    "alias": "perbacco-san-francisco"
  },
  {
    "alias": "amandas-restaurant-hoboken-2"
  },
  {
    "alias": "rsly-wing-snob"
  },
  {
    "alias": "bar-b-new-york"
  },
  {
    "alias": "galpão-gaucho-brazilian-steakhouse-cupertino-3"
  },
  {
    "alias": "amaranth-restaurant-new-york"
  },
  {
    "alias": "rsly-fabrika"
  },
  {
    "alias": "rsly-spoon-house-korean-cuisine-and-cocktails"
  },
  {
    "alias": "yamashiro-hollywood-hollywood"
  },
  {
    "alias": "kappo-masa-new-york"
  },
  {
    "alias": "blackstones-grille-southport"
  },
  {
    "alias": "rsly-ly-time-restaurant"
  },
  {
    "alias": "zingari-ristorante-and-tapas-bar-san-francisco"
  },
  {
    "alias": "down-the-hatch-new-york"
  },
  {
    "alias": "chazz-palminteri-italian-restaurant-new-york-4"
  },
  {
    "alias": "rsly-true-food-kitchen"
  },
  {
    "alias": "liberty-house-restaurant-jersey-city-2"
  },
  {
    "alias": "bobby-vans-steakhouse-new-york-11"
  },
  {
    "alias": "cafe-milano-washington"
  },
  {
    "alias": "rsly-hildur"
  },
  {
    "alias": "rsly-la-braise-african-grill---springfield"
  },
  {
    "alias": "rsly-chili-s-grill-bar"
  },
  {
    "alias": "emmetts-new-york-2"
  },
  {
    "alias": "ms-fus-yummy-food-truck-jersey-city"
  },
  {
    "alias": "hillstone-san-francisco-4"
  },
  {
    "alias": "rsly-red-horse-by-david-burke---bernards-inn"
  },
  {
    "alias": "the-bar-room-new-york"
  },
  {
    "alias": "rsly-lamplighter-restaurant-pub"
  },
  {
    "alias": "rsly-rico-rico-taqueria"
  },
  {
    "alias": "serra-by-birreria-at-eataly-flatiron-new-york"
  },
  {
    "alias": "el-compadre-los-angeles-7"
  },
  {
    "alias": "the-standard-plaza-new-york"
  },
  {
    "alias": "rsly-gladstone-corner-deli-grill"
  },
  {
    "alias": "rsly-wheelfish"
  },
  {
    "alias": "rsly-zen-ramen-poke"
  },
  {
    "alias": "rsly-hunan-cafe---king-street-halal-"
  },
  {
    "alias": "the-garden-court-san-francisco"
  },
  {
    "alias": "kazunori-nomad-new-york"
  },
  {
    "alias": "rsly-grand-ole-bbq-flinn-springs"
  },
  {
    "alias": "rsly-milu"
  },
  {
    "alias": "amber-steakhouse-brooklyn"
  },
  {
    "alias": "rsly-wow-pizzeria-lincoln-park"
  },
  {
    "alias": "cjs-crab-shack-miami-beach"
  },
  {
    "alias": "routier-san-francisco"
  },
  {
    "alias": "antique-bar-and-bakery-hoboken-2"
  },
  {
    "alias": "bonsaii-tapas-and-wine-bar-new-york-2"
  },
  {
    "alias": "a1-asian-fusion-new-york-7"
  },
  {
    "alias": "cast-iron-chef-chop-house-and-oyster-bar-new-haven"
  },
  {
    "alias": "pomp-and-circumstance-dining-williamsburg"
  },
  {
    "alias": "rsly-trap-rock-restaurant-brewery"
  },
  {
    "alias": "andreas-ristorante-italiano-waldwick-5"
  },
  {
    "alias": "sardinia-enoteca-ristorante-miami-beach"
  },
  {
    "alias": "rsly-pren-kitchen"
  },
  {
    "alias": "piccola-cucina-uptown-new-york"
  },
  {
    "alias": "jacks-wife-freda-new-york-2"
  },
  {
    "alias": "rsly-sabor-hondure-o-504"
  },
  {
    "alias": "carbones-prime-rocky-hill-2"
  },
  {
    "alias": "sushi-sushi-new-york-6"
  },
  {
    "alias": "pineapple-club-new-york"
  },
  {
    "alias": "villa-azur-miami-beach-2"
  },
  {
    "alias": "rsly-maiella"
  },
  {
    "alias": "dishdash-sunnyvale"
  },
  {
    "alias": "archer-and-goat-new-york"
  },
  {
    "alias": "rsly-farmer-s-table-chula-vista"
  },
  {
    "alias": "rsly-the-greek-bar-"
  },
  {
    "alias": "ubani-new-york-2"
  },
  {
    "alias": "rsly-off-the-grill"
  },
  {
    "alias": "rsly-casa-de-pasta"
  },
  {
    "alias": "sushi-gakyu-washington"
  },
  {
    "alias": "rsly-daily-provisions---brookfield-place"
  },
  {
    "alias": "chama-mama-chelsea-new-york"
  },
  {
    "alias": "ambar-arlington-4"
  },
  {
    "alias": "catch-nyc-new-york"
  },
  {
    "alias": "nami-nori-new-york"
  },
  {
    "alias": "tuscany-steakhouse-new-york"
  },
  {
    "alias": "rsly-the-mary-lane"
  },
  {
    "alias": "lysee-new-york-5"
  },
  {
    "alias": "august-new-york-3"
  },
  {
    "alias": "rsly-giovanna-s-kitchen-inc"
  },
  {
    "alias": "rsly-the-miner-s-apron"
  },
  {
    "alias": "sofreh-brooklyn"
  },
  {
    "alias": "corner-bistro-new-york"
  },
  {
    "alias": "bar-jamón-new-york-2"
  },
  {
    "alias": "rsly-the-forgotten-flour"
  },
  {
    "alias": "rsly-buffalo-wings-pizza-chiken"
  },
  {
    "alias": "rsly-the-queensboro"
  },
  {
    "alias": "king-new-york-3"
  },
  {
    "alias": "the-polo-bar-new-york"
  },
  {
    "alias": "casa-lever-new-york"
  },
  {
    "alias": "bonjour-crepes-and-wine-new-york-2"
  },
  {
    "alias": "the-deck-at-island-gardens-miami-3"
  },
  {
    "alias": "gupshup-new-york"
  },
  {
    "alias": "boucherie-union-square-new-york-2"
  },
  {
    "alias": "peak-new-york-2"
  },
  {
    "alias": "bobos-steakhouse-san-francisco-2"
  },
  {
    "alias": "rsly-apteka"
  },
  {
    "alias": "thyme-palo-alto"
  },
  {
    "alias": "soogil-new-york"
  },
  {
    "alias": "the-tailor-public-house-new-york"
  },
  {
    "alias": "haven-rooftop-new-york"
  },
  {
    "alias": "avant-garden-new-york"
  },
  {
    "alias": "rsly-soju"
  },
  {
    "alias": "wildair-new-york"
  },
  {
    "alias": "compass-rose-washington-3"
  },
  {
    "alias": "green-fig-new-york-2"
  },
  {
    "alias": "el-toro-gourmet-meats-seafood-deli-lake-forest"
  },
  {
    "alias": "rsly-elly-s-brunch-cafe-cumberland-ave-"
  },
  {
    "alias": "sear-house-closter-2"
  },
  {
    "alias": "rsly-santa-fe-bk"
  },
  {
    "alias": "omakase-by-korami-new-york"
  },
  {
    "alias": "il-pesce-at-eataly-flatiron-new-york"
  },
  {
    "alias": "watermark-new-york"
  },
  {
    "alias": "rsly-vogue-tavern"
  },
  {
    "alias": "rsly-asian-delight"
  },
  {
    "alias": "rsly-palmitas-mexican-food"
  },
  {
    "alias": "rsly-the-wilder"
  },
  {
    "alias": "roxy-bar-new-york-2"
  },
  {
    "alias": "rsly-kai-zabb"
  },
  {
    "alias": "rsly-albero-verde"
  },
  {
    "alias": "rsly-origin-french-thai"
  },
  {
    "alias": "rsly-sorrento-s-pizza"
  },
  {
    "alias": "wolfgangs-steakhouse-new-york-10"
  },
  {
    "alias": "rsly-the-after-char-broil-grill-ice-cream"
  },
  {
    "alias": "pepolino-restaurant-new-york"
  },
  {
    "alias": "rsly-famous-cafe"
  },
  {
    "alias": "rsly-chez-adele"
  },
  {
    "alias": "frevo-new-york"
  },
  {
    "alias": "home-sweet-harlem-new-york"
  },
  {
    "alias": "rsly-mola"
  },
  {
    "alias": "rsly-junction-bistro-bar-bakery-chevy-chase"
  },
  {
    "alias": "sugarfish-by-sushi-nozawa-new-york-2"
  },
  {
    "alias": "edge-steak-and-bar-miami-4"
  },
  {
    "alias": "rsly-kobano"
  },
  {
    "alias": "rsly-long-valley-pub-brewery-at-restaurant-village"
  },
  {
    "alias": "agora-dc-washington-8"
  },
  {
    "alias": "rsly-charrito-s"
  },
  {
    "alias": "il-punto-ristorante-new-york-4"
  },
  {
    "alias": "goodfellas-restaurant-new-haven-2"
  },
  {
    "alias": "moko-new-york"
  },
  {
    "alias": "shuko-new-york-2"
  },
  {
    "alias": "rsly-ten-seconds-yunnan-rice-noodle"
  },
  {
    "alias": "rsly-pizza-da-napoli"
  },
  {
    "alias": "rsly-moonshine-modern-supper-club"
  },
  {
    "alias": "rsly-the-rose-bar-and-grille"
  },
  {
    "alias": "rsly-buka---nigerian-restaurant-and-lounge"
  },
  {
    "alias": "scomas-restaurant-san-francisco-3"
  },
  {
    "alias": "rsly-tikka"
  },
  {
    "alias": "rsly-el-andale-sports-bar-restaurant"
  },
  {
    "alias": "rsly-bananas"
  },
  {
    "alias": "rsly-rocco-s-burgers-dogs-and-fries"
  },
  {
    "alias": "rsly-frick-park-tavern"
  },
  {
    "alias": "rsly-lawrence-hall"
  },
  {
    "alias": "lucien-new-york"
  },
  {
    "alias": "ponche-taqueria-and-cantina-new-york"
  },
  {
    "alias": "socarrat-paella-bar-midtown-east-new-york-3"
  },
  {
    "alias": "kings-fish-house-corona-corona"
  },
  {
    "alias": "rsly-maman-joon-kitchen"
  },
  {
    "alias": "nisei-san-francisco-3"
  },
  {
    "alias": "the-liberty-new-york-3"
  },
  {
    "alias": "l-appart-new-york"
  },
  {
    "alias": "rsly-dunkin-"
  },
  {
    "alias": "fieldtrip-rockefeller-center-new-york-2"
  },
  {
    "alias": "asa-los-gatos-los-gatos-2"
  },
  {
    "alias": "nobu-fifty-seven-new-york-2"
  },
  {
    "alias": "main-wah-restaurant-stratford"
  },
  {
    "alias": "house-of-lasagna-new-york"
  },
  {
    "alias": "mui-new-york"
  },
  {
    "alias": "anixi-new-york"
  },
  {
    "alias": "the-chemistry-room-new-york-3"
  },
  {
    "alias": "rsly-odds-bar-bistro"
  },
  {
    "alias": "aria-hells-kitchen-new-york-5"
  },
  {
    "alias": "omars-mediterranean-cuisine-new-york-2"
  },
  {
    "alias": "azalea-new-york-2"
  },
  {
    "alias": "vatan-indian-vegetarian-new-york-2"
  },
  {
    "alias": "rsly-alta-calidad"
  },
  {
    "alias": "rsly-juanita-s-kitchen"
  },
  {
    "alias": "21-greenpoint-brooklyn-2"
  },
  {
    "alias": "ms-yoo-new-york-2"
  },
  {
    "alias": "hirohisa-new-york"
  },
  {
    "alias": "le-bilboquet-new-york-2"
  },
  {
    "alias": "jams-new-york-3"
  },
  {
    "alias": "rsly-patti-s-pasticceria"
  },
  {
    "alias": "telefèric-barcelona-los-gatos-los-gatos-2"
  },
  {
    "alias": "mercury-bar-west-new-york-5"
  },
  {
    "alias": "rsly-tillie-s-restaurant"
  },
  {
    "alias": "nina-may-washington"
  },
  {
    "alias": "sexy-fish-miami-miami"
  },
  {
    "alias": "the-chester-new-york"
  },
  {
    "alias": "selbys-redwood-city-2"
  },
  {
    "alias": "rsly-locanda-verde-tribeca"
  },
  {
    "alias": "ninos-restaurant-new-york"
  },
  {
    "alias": "rsly-simply-noodles-dim-sum-bryant-park-"
  },
  {
    "alias": "fleming-s-prime-steakhouse-and-wine-bar-west-hartford-2"
  },
  {
    "alias": "allora-ristorante-new-york-2"
  },
  {
    "alias": "love-korean-bbq-new-york"
  },
  {
    "alias": "rsly-erin-s-isle"
  },
  {
    "alias": "pauls-on-times-square-new-york"
  },
  {
    "alias": "mona-lisa-restaurant-san-francisco"
  },
  {
    "alias": "mortons-the-steakhouse-coral-gables"
  },
  {
    "alias": "hurleys-new-york-4"
  },
  {
    "alias": "rsly-hapgoods-restaurant-bar"
  },
  {
    "alias": "due-west-new-york"
  },
  {
    "alias": "rsly-yasouvlaki"
  },
  {
    "alias": "madison-and-vine-new-york"
  },
  {
    "alias": "mother-wolf-los-angeles"
  },
  {
    "alias": "rsly-canal-street-eatery-and-market"
  },
  {
    "alias": "rsly-bt-s-bethesda"
  },
  {
    "alias": "rsly-chef-geoff-s"
  },
  {
    "alias": "sugarfish-by-sushi-nozawa-new-york"
  },
  {
    "alias": "rsly-alta-via"
  },
  {
    "alias": "wolfgangs-steakhouse-new-york-2"
  },
  {
    "alias": "lilli-and-loo-new-york"
  },
  {
    "alias": "rsly-sushi-nova---chicago"
  },
  {
    "alias": "tommy-bahama-restaurant-bar-store-new-york-new-york"
  },
  {
    "alias": "union-league-cafe-new-haven"
  },
  {
    "alias": "kaboozs-bar-and-grill-new-york"
  },
  {
    "alias": "uchi-miami"
  },
  {
    "alias": "rsly-las-leyendas-morris-plains"
  },
  {
    "alias": "rsly-millie-s"
  },
  {
    "alias": "rsly-providence-bar-kitchen"
  },
  {
    "alias": "rsly-two-hands-corn-dogs---las-america"
  },
  {
    "alias": "nocciola-ristorante-new-york-3"
  },
  {
    "alias": "lenwich-new-york-25"
  },
  {
    "alias": "rsly-cafe-samarkand"
  },
  {
    "alias": "rsly-osteria-carlina-west-village"
  },
  {
    "alias": "rsly-amaranto"
  },
  {
    "alias": "sushi-azabu-new-york"
  },
  {
    "alias": "xixa-brooklyn"
  },
  {
    "alias": "aya-sushi-new-york"
  },
  {
    "alias": "hudson-malone-a-new-york-joint-new-york"
  },
  {
    "alias": "mr-chow-new-york"
  },
  {
    "alias": "back-to-back-san-francisco"
  },
  {
    "alias": "soregashi-los-angeles"
  },
  {
    "alias": "new-mill-restaurant-plantsville"
  },
  {
    "alias": "quechua-nostra-peruvian-food-new-york-5"
  },
  {
    "alias": "the-keg-room-new-york"
  },
  {
    "alias": "red-rooster-overtown-miami"
  },
  {
    "alias": "hillstone-restaurant-new-york"
  },
  {
    "alias": "masseria-washington-2"
  },
  {
    "alias": "istanbul-bay-new-york"
  },
  {
    "alias": "rsly-la-casa-del-sabor"
  },
  {
    "alias": "sunac-natural-deli-brooklyn"
  },
  {
    "alias": "georgia-browns-washington-3"
  },
  {
    "alias": "rsly-the-katherine-restaurant"
  },
  {
    "alias": "rsly-mexican-sazon-lichita"
  },
  {
    "alias": "rsly-new-york-pizza-and-italian-restaurant"
  },
  {
    "alias": "so-good-closter"
  },
  {
    "alias": "rsly-hills-of-herat-basking-ridge"
  },
  {
    "alias": "xacalli-kitchen-silverado"
  },
  {
    "alias": "abc-kitchen-new-york"
  },
  {
    "alias": "rsly-cowabunga-pizza-pies"
  },
  {
    "alias": "rsly-kiku-hibachi-sushi"
  },
  {
    "alias": "rsly-asian-express"
  },
  {
    "alias": "the-parlour-at-the-roger-hotel-new-york"
  },
  {
    "alias": "tatel-miami-miami-beach-2"
  },
  {
    "alias": "rsly-3-west"
  },
  {
    "alias": "rsly-aventino-cucina"
  },
  {
    "alias": "rsly-yolo-cafe"
  },
  {
    "alias": "rsly-little-biggs---fidi"
  },
  {
    "alias": "rsly-zhumi-bakery-restaurant"
  },
  {
    "alias": "p-j-clarkes-new-york-3"
  },
  {
    "alias": "rsly-branda-s-italian-grill"
  },
  {
    "alias": "mila-restaurant-miami-beach-3"
  },
  {
    "alias": "forty-carrots-new-york-2"
  },
  {
    "alias": "caffe-vialetto-coral-gables-2"
  },
  {
    "alias": "wolf-and-lamb-steakhouse-new-york"
  },
  {
    "alias": "la-ferme-chevy-chase"
  },
  {
    "alias": "etc-steakhouse-teaneck"
  },
  {
    "alias": "han-sung-bbq-santa-clara-2"
  },
  {
    "alias": "glasserie-brooklyn-2"
  },
  {
    "alias": "fruit-and-veggie-guy-new-york"
  },
  {
    "alias": "wayla-new-york"
  },
  {
    "alias": "delice-and-sarrasin-new-york"
  },
  {
    "alias": "okoze-sushi-san-francisco"
  },
  {
    "alias": "cull-and-pistol-oyster-bar-new-york"
  },
  {
    "alias": "ofrenda-new-york"
  },
  {
    "alias": "rsly-mr-mario-pollos-a-la-brasa"
  },
  {
    "alias": "rsly-ace-new-york-giant-pizza"
  },
  {
    "alias": "felix-new-york"
  },
  {
    "alias": "rsly-uzbek-food"
  },
  {
    "alias": "blue-ribbon-sushi-bar-rock-center-new-york-3"
  },
  {
    "alias": "rsly-roots-caf-"
  },
  {
    "alias": "le-bernardin-new-york"
  },
  {
    "alias": "rsly-urban-taqueria"
  },
  {
    "alias": "swahili-village-beltsville-6"
  },
  {
    "alias": "yopparai-new-york"
  },
  {
    "alias": "osaka-miami"
  },
  {
    "alias": "area-31-miami"
  },
  {
    "alias": "kin-khao-san-francisco-2"
  },
  {
    "alias": "rsly-santo-patio"
  },
  {
    "alias": "eyval-brooklyn"
  },
  {
    "alias": "st-jardim-new-york"
  },
  {
    "alias": "raos-hollywood-los-angeles-2"
  },
  {
    "alias": "una-pizza-napoletana-new-york-2"
  },
  {
    "alias": "citron-baltimore-2"
  },
  {
    "alias": "sasabune-express-new-york-2"
  },
  {
    "alias": "copra-san-francisco-2"
  },
  {
    "alias": "rsly-chengdu-gourmet-squirrel-hill-"
  },
  {
    "alias": "rsly-maggiano-s-little-italy"
  },
  {
    "alias": "rsly-bhatti-himalayan-grill-indian-cuisine"
  },
  {
    "alias": "rasa-new-york"
  },
  {
    "alias": "flip-new-york-2"
  },
  {
    "alias": "orsay-new-york"
  },
  {
    "alias": "shellys-back-room-washington-2"
  },
  {
    "alias": "rsly-thai-kitchen"
  },
  {
    "alias": "rsly-mister-chicken-bar"
  },
  {
    "alias": "rsly-byrds-hot-chicken-west-loop"
  },
  {
    "alias": "hatsuhana-new-york"
  },
  {
    "alias": "rsly-mezcal-mexican-cantina"
  },
  {
    "alias": "rsly-burgatory"
  },
  {
    "alias": "tasca-new-york-2"
  },
  {
    "alias": "coletta-new-york-2"
  },
  {
    "alias": "rsly-senza-is-not-a-restaurant-"
  },
  {
    "alias": "sixty-three-clinton-new-york"
  },
  {
    "alias": "uncaged-mimosas-washington"
  },
  {
    "alias": "honey-badger-brooklyn-2"
  },
  {
    "alias": "bobby-vans-steakhouse-new-york-13"
  },
  {
    "alias": "rsly-concettina"
  },
  {
    "alias": "stk-steakhouse-miami-beach-miami-beach"
  },
  {
    "alias": "la-lupa-ristorante-north-haven"
  },
  {
    "alias": "prestons-market-miami-beach-2"
  },
  {
    "alias": "sirenetta-seafood-and-raw-bar-hoboken"
  },
  {
    "alias": "westlight-brooklyn"
  },
  {
    "alias": "himalayan-curry-house-restaurant-and-bar-new-york"
  },
  {
    "alias": "hudson-and-co-jersey-city"
  },
  {
    "alias": "bistango-new-york-8"
  },
  {
    "alias": "rsly-grist-house-craft-brewery"
  },
  {
    "alias": "rsly-lovely-s-old-fashioned"
  },
  {
    "alias": "rsly-baja-bar-grill"
  },
  {
    "alias": "kame-new-york-2"
  },
  {
    "alias": "sushi-of-gari-new-york-15"
  },
  {
    "alias": "korali-estiatorio-new-york"
  },
  {
    "alias": "the-malt-house-new-york"
  },
  {
    "alias": "rsly-sanjeevani-indian-cuisine"
  },
  {
    "alias": "harlem-shake-new-york"
  },
  {
    "alias": "manta-wynwood-miami"
  },
  {
    "alias": "kusakabe-san-francisco"
  },
  {
    "alias": "kappo-dc-washington"
  },
  {
    "alias": "rsly-le-petit-village"
  },
  {
    "alias": "nami-nori-brooklyn"
  },
  {
    "alias": "rsly-t-k-"
  },
  {
    "alias": "rsly-forest-hills-station-house"
  },
  {
    "alias": "rsly-the-porch"
  },
  {
    "alias": "mcloones-boathouse-west-orange"
  },
  {
    "alias": "barbetta-new-york"
  },
  {
    "alias": "the-lambs-club-new-york"
  },
  {
    "alias": "momoya-soho-new-york"
  },
  {
    "alias": "norcina-san-francisco-2"
  },
  {
    "alias": "miznon-new-york"
  },
  {
    "alias": "dizzys-club-new-york"
  },
  {
    "alias": "rsly-mr-dre-kitchen-bar"
  },
  {
    "alias": "seamores-upper-east-side-new-york"
  },
  {
    "alias": "zinc-new-haven-new-haven-2"
  },
  {
    "alias": "la-fonda-new-york-3"
  },
  {
    "alias": "piccolo-bistro-ridgewood"
  },
  {
    "alias": "rsly-manetta-s-ristorante"
  },
  {
    "alias": "tsukimi-new-york"
  },
  {
    "alias": "meteora-los-angeles-2"
  },
  {
    "alias": "rsly-polo-s-bar-grill"
  },
  {
    "alias": "rosemary-s-new-york"
  },
  {
    "alias": "rsly-little-blackbird"
  },
  {
    "alias": "yamame-rancho-santa-margarita-5"
  },
  {
    "alias": "earls-beer-and-cheese-new-york"
  },
  {
    "alias": "jacob-restaurant-new-york-4"
  },
  {
    "alias": "wine-cellar-restaurant-los-gatos"
  },
  {
    "alias": "rsly-lime-in-the-coconut"
  },
  {
    "alias": "ladurée-new-york-soho-new-york"
  },
  {
    "alias": "rsly-rica-arepa-addison-st-venezuelan-cuisine"
  },
  {
    "alias": "rsly-burger-lobster-bryant-park"
  },
  {
    "alias": "the-hugh-new-york"
  },
  {
    "alias": "hui-restaurant-and-bar-new-york"
  },
  {
    "alias": "omen-azen-new-york"
  },
  {
    "alias": "atrio-wine-bar-and-restaurant-new-york"
  },
  {
    "alias": "common-lot-millburn"
  },
  {
    "alias": "rsly-jimmy-john-s"
  },
  {
    "alias": "altesi-downtown-new-york"
  },
  {
    "alias": "vinegar-hill-house-brooklyn"
  },
  {
    "alias": "rsly-patti-s-la-cucina"
  },
  {
    "alias": "elios-new-york"
  },
  {
    "alias": "rsly-mangu-patio"
  },
  {
    "alias": "rsly-louis-jamaican-cuisine-signature-cakes-2"
  },
  {
    "alias": "the-greenhouse-washington-2"
  },
  {
    "alias": "rsly--chill-tavern-bbq-flushing"
  },
  {
    "alias": "umami-sushi-new-york"
  },
  {
    "alias": "tempura-matsui-new-york"
  },
  {
    "alias": "urban-hawker-new-york"
  },
  {
    "alias": "baoli-miami-miami-beach-5"
  },
  {
    "alias": "sushi-fussion-47th-nyc-new-york"
  },
  {
    "alias": "nobu-miami-miami-beach"
  },
  {
    "alias": "gogi-yogi-washington-2"
  },
  {
    "alias": "soho-park-new-york-6"
  },
  {
    "alias": "nobu-washington-d-c-washington-2"
  },
  {
    "alias": "rsly-cielo-rojo-restaurant"
  },
  {
    "alias": "rsly-arre-sinaloa"
  },
  {
    "alias": "peppercorns-grill-hartford"
  },
  {
    "alias": "lpm-restaurant-and-bar-miami"
  },
  {
    "alias": "sasa-japanese-restaurant-san-francisco-2"
  },
  {
    "alias": "gelsons-market-west-hollywood"
  },
  {
    "alias": "la-sirène-uws-new-york"
  },
  {
    "alias": "dainobu-new-york-3"
  },
  {
    "alias": "j-hollingers-watermans-chophouse-silver-spring"
  },
  {
    "alias": "brooklyn-chop-house-time-square-new-york"
  },
  {
    "alias": "victors-cafe-new-york-6"
  },
  {
    "alias": "rsly-villaggio-ristorante-italian-bistro"
  },
  {
    "alias": "barcha-san-francisco"
  },
  {
    "alias": "rsly-barrel-house-kitchen-tap"
  },
  {
    "alias": "mortons-of-chicago-washington"
  },
  {
    "alias": "annam-new-york-2"
  },
  {
    "alias": "rsly-crazy-conchaz"
  },
  {
    "alias": "rsly-shinwa-izakaya"
  },
  {
    "alias": "cheltons-bar-and-grill-manhattan"
  },
  {
    "alias": "octavia-san-francisco"
  },
  {
    "alias": "rsly-trattoria-da-lina"
  },
  {
    "alias": "the-library-at-the-public-new-york"
  },
  {
    "alias": "degrees-bistro-washington"
  },
  {
    "alias": "rsly-thai-bistro"
  },
  {
    "alias": "sapoara-new-york-6"
  },
  {
    "alias": "quinto-miami"
  },
  {
    "alias": "tessa-new-york"
  },
  {
    "alias": "rsly-mariscos-la-capital-mexican-seafood-restaurant-"
  },
  {
    "alias": "cecconis-dumbo-brooklyn"
  },
  {
    "alias": "rsly-madam-ji-ki-shaadi"
  },
  {
    "alias": "au-cheval-new-york-7"
  },
  {
    "alias": "rsly-year-of-the-fortune-chinese"
  },
  {
    "alias": "rsly-ju-ichi-japanese-restaurant"
  },
  {
    "alias": "rsly-mammoth-poke-ramen"
  },
  {
    "alias": "casablanca-on-the-bay-miami"
  },
  {
    "alias": "rsly-sai-japanese-bistro"
  },
  {
    "alias": "mortons-restaurant-new-york"
  },
  {
    "alias": "rsly-dialtone-coffee-wine-bar"
  },
  {
    "alias": "gyu-kaku-japanese-bbq-new-york-2"
  },
  {
    "alias": "oceans-ten-miami-beach"
  },
  {
    "alias": "laojie-hotpot-manhattan-new-york"
  },
  {
    "alias": "mrs-an-new-york-3"
  },
  {
    "alias": "rsly-mito"
  },
  {
    "alias": "wayan-new-york-4"
  },
  {
    "alias": "rai-rai-ken-harlem-new-york"
  },
  {
    "alias": "valla-table-new-york"
  },
  {
    "alias": "rsly-wonder-springfield"
  },
  {
    "alias": "the-clam-new-york"
  },
  {
    "alias": "liberty-prime-steakhouse-jersey-city"
  },
  {
    "alias": "morandi-new-york"
  },
  {
    "alias": "coqueta-san-francisco"
  },
  {
    "alias": "rsly-mazmez-middle-eastern-grill"
  },
  {
    "alias": "slatterys-midtown-pub-new-york"
  },
  {
    "alias": "rsly-il-supremo-italian-restaurant-ii"
  },
  {
    "alias": "lincoln-ristorante-new-york"
  },
  {
    "alias": "ammos-estiatorio-new-york-4"
  }
]